import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {StoreContext} from "../../../store/StoreContext";
import DialogFormFinding from "../../../components/dialog-form-finding/DialogFormFinding";
import DialogFormCommitments from "../../../components/dialog-form-commitments/DialogFormCommitments";
import {v4 as uuid} from "uuid";
import {swalAlert, swalWarningAlert, toast} from "../../../alerts/sweetalert";
import FindingGridIncident from "../../../components/finding-grid-incident/FindingGridIncident";
import CommitmentsGrid from "../../../components/commitments-grid/CommitmentsGrid";
import _ from "lodash";
import {useFormik} from "formik";
import moment from "moment/moment";
import {
  base64ToBlob,
  fileToBase64,
  handleCleanTitle,
  imageCompressor,
} from "../../../helpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faAdd,
  faCamera,
  faIdCard,
  faImages,
  faPenClip,
  faPlus,
  faTimes,
  faTrash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {storeForm, updateForm} from "../../../util/save-forms";
import useMain from "../../../hooks/useMain";
import useFormParams from "../../../hooks/useFormParams";
import {getUsers} from "../../../mongo-db/users";
import {getLocal, putLocal} from "../../../helpers/local-storage";
import {LOCAL_NEW_STATE, LOCAL_UPDATE_STATE} from "../../../constants/states";
import FormSection from "../../../components/form-section/FormSection";
import FormSubSection from "../../../components/form-sub-section/FormSubSection";
import {storeImages, updateImages} from "../../../util/save-images";
import {API_URL} from "../../../mongo-db/conection";
import {COLOR_DANGER} from "../../../constants/colors";
import {format} from "rut.js";
import {Camera, CameraResultType, CameraSource} from "@capacitor/camera";
import {CameraDirection} from "@capacitor-community/barcode-scanner";
import {DialogFormSignature} from "../../../components/dialog-form-signature/DialogFormSignature";

const defaultSection = {
  id: moment().unix() + _.random(0, 1000),
  sectionName: "",
  evaluation: "",
  observations: "",
  tasksItems: [""],
  dangers: [""],
  precautionaryMeasures: [""],
};
const defaultElement = {
  id: moment().unix() + _.random(0, 1000),
  name: "",
  desciption: "",
  state: "",
  comments: "",
};
const defaultCollaborator = {
  id: moment().unix() + _.random(0, 1000),
  rut: "",
  name: "",
  state: "",
  comments: "",
  sections: [{id: moment().valueOf(), section: "", yn: "", observation: ""}],
};

const Forms = () => {
  // formId --> Id del formulario a editar.
  // templateId --> Id de la plantilla para formulario.
  // formType --> Id del tipo de formulario.
  const {templateId, formId, rol} = useParams();
  const navigate = useNavigate();
  const {
    setAppTitle,
    formsAD,
    formsAM,
    formsP,
    formsADM,
    session,
    online,
    setLoading,
    platform,
  } = useContext(StoreContext);
  const {fetchSavedForm, fetchImagesByForm, syncUpdatedForm, fetchSavedForms} =
    useMain();

  // Datos de nuevas colecciones (Centers, FormParams)
  const {
    areas: _rawAreas,
    flatCenters: _rawCenters,
    categories,
    results,
    findingCategories,
    yesOrNo: questions,
    machineTypes: machineType,
    itemsMachine,
    states,
    ssoMachines: machinesSso,
    ssoQuestions,
    executionTypes,
    workTypes,
  } = useFormParams(templateId);

  const _assigned = session?.assignedCenters || [];

  const normalize = s => (s || "").toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const eq = (a, b) => normalize(a) === normalize(b);

  const areas = useMemo(() => {
    if (Number(session?.profile) === 1) return _rawAreas;
    if (_assigned.length === 0) return _rawAreas;
    if (_assigned.some(ac => !ac.area)) return _rawAreas;
    return _rawAreas.filter(a => _assigned.some(ac => eq(ac.area, a.title)));
  }, [_rawAreas, _assigned, session?.profile]);

  const allCenters = useMemo(() => {
    if (Number(session?.profile) === 1) return _rawCenters;
    if (_assigned.length === 0) return _rawCenters;
    if (_assigned.some(ac => !ac.area)) return _rawCenters;
    return _rawCenters.filter(c => {
      const area = _rawAreas.find(a => a.id === c.areaId);
      if (!area) return false;
      const matching = _assigned.filter(ac => eq(ac.area, area.title));
      if (matching.length === 0) return false;
      if (matching.some(ac => !ac.instalacion)) return true;
      return matching.some(ac => eq(ac.instalacion, c.title));
    });
  }, [_rawCenters, _rawAreas, _assigned]);

  const [saving, setSaving] = useState(false);
  const [openFindings, setOpenFindings] = useState(false);
  const [openCommitments, setOpenCommitments] = useState(false);
  const [form, setForm] = useState({});
  const [findings, setFindings] = useState([]);
  const [commitments, setCommitments] = useState([]);
  const [finding, setFinding] = useState(null);
  const [commitment, setCommitment] = useState(null);
  const [initialValues, setInitialValues] = useState({});
  const [state, setState] = useState(null);
  const [elements, setElements] = useState([defaultElement]);
  const [collaborators, setCollaborators] = useState([defaultCollaborator]);
  const [machines, setMachines] = useState({});
  const [collaboratorIndex, setCollaboratorIndex] = useState(0);
  const [sections, setSections] = useState([]);
  const [questionsMachine, setQuestionsMachine] = useState([]);
  const [isPreviewFinding, setIsPreviewFinding] = useState(false);
  const [isPreviewCommitment, setIsPreviewCommitment] = useState(false);
  const [responsible, setResponsible] = useState([]);
  const usersRef = useRef([]);
  const [centers, setCenters] = useState([]);
  const [actions, setActions] = useState([]);
  const [savedQuestions, setSavedQuestions] = useState({});
  const [collaboratorSignature, setCollaboratorSignature] = useState(null);
  const [originalUsername, setOriginalUsername] = useState(null);
  const [incidentImages, setIncidentImages] = useState({});
  const [inlineCategories, setInlineCategories] = useState({});
  const incidentUploadRefs = useRef({});

  const handleStoreImages = async (formId, data) => {
    console.log('[handleStoreImages] Iniciando para formId:', formId);

    const result = await fetchImagesByForm(formId);
    console.log('[handleStoreImages] fetchImagesByForm retornó:', result ? '✓ Existe' : '✗ No existe o error');

    const store = !result
      ? (console.log('[handleStoreImages] Creando nuevas imágenes...'), storeImages(data))
      : (console.log('[handleStoreImages] Actualizando imágenes existentes...'), updateImages(formId, data));

    const storeResult = await store;
    console.log('[handleStoreImages] Resultado final:', storeResult === true ? '✓ Éxito' : `✗ Error (${storeResult})`);
    return storeResult;
  };

  const getImageErrorMsg = (result, imgCount) => {
    const hint = imgCount > 5
      ? ` Este formulario tiene ${imgCount} imágenes, intente reducir la cantidad para evitar problemas.`
      : "";
    switch (result) {
      case "quota": return "Almacenamiento local lleno. Conecte a internet para sincronizar formularios pendientes y liberar espacio.";
      case "payload_too_large": return `Las imágenes exceden el tamaño máximo permitido por el servidor.${hint || " Reduzca la cantidad de imágenes e intente nuevamente."}`;
      case "network_error": return `Error de conexión al guardar imágenes. Verifique su conexión a internet e intente nuevamente.${hint}`;
      case "server_error": return `Error del servidor al guardar imágenes.${hint || " Intente nuevamente en unos minutos."}`;
      default: return `Error al guardar imágenes.${hint || " Intente reducir la cantidad de imágenes o verifique su conexión."}`;
    }
  };

  const handleOnSubmit = async values => {
    if (form?.FormType === 12) {
      if (!values["buceo-declaracionLeida"]) {
        toast({ icon: "warning", title: "Debe confirmar que ha leído y comprende la declaración." });
        return;
      }
      const selectedResult = results.find(r => String(r.id) === String(values["p-5"]));
      if (selectedResult?.title?.toLowerCase().includes("no aprobad") && !values["buceo-observacionesRechazo"]?.trim()) {
        toast({ icon: "warning", title: "Debe ingresar las observaciones a subsanar." });
        return;
      }
    }
    if (isIncidentReport) {
      for (const action of actions) {
        const lesionQ = action.Preguntas?.find(q =>
          q.Titulo?.toLowerCase().includes("lesión") || q.Titulo?.toLowerCase().includes("lesion")
        );
        if (lesionQ) {
          const val = values[`psn-${action.Id}-${lesionQ.Id}`];
          if (!val) {
            toast({ icon: "warning", title: "Debe indicar si el incidente generó lesión." });
            return;
          }
        }
      }
    }

    setSaving(true);

    let newFormId = formId;
    if (!formId) {
      const unique_id = uuid();
      newFormId = unique_id.slice(0, 8);
    }

    const _findings = findings.map(f => _.omit(f, ["images"]));
    const dataImages = {
      IdForm: newFormId,
      images: findings.reduce((acc, el) => {
        acc[el.HallazgoId] = el.images;
        return acc;
      }, {}),
    };

    const estimatedSize = new Blob([JSON.stringify(dataImages)]).size;
    const estimatedMB = (estimatedSize / 1024 / 1024).toFixed(1);
    const maxPayloadMB = 14;
    if (estimatedSize > maxPayloadMB * 1024 * 1024) {
      setSaving(false);
      return swalWarningAlert(
        `El formulario contiene demasiadas imágenes (${estimatedMB} MB). El límite del servidor es ${maxPayloadMB} MB. Por favor reduzca la cantidad o calidad de las imágenes.`,
        "Entendido"
      );
    }

    let newValues = _.cloneDeep(values);
    if (!formId)
      newValues = {
        ...newValues,
        "p-2_4": moment().format("HH:mm"),
      };

    let data = {
      IdForm: newFormId,
      formType: form?.FormType,
      Tipo: Number(templateId),
      Titulo: form.Titulo,
      username: (formId && originalUsername) ? originalUsername : (session?.username.toLocaleLowerCase() || ""),
      UserId: 1,
      FechaFormulario: moment().format("YYYY-MM-DD HH:mm"),
      Preguntas: newValues,
      hallazgos: _findings,
      compromisos: commitments,
      collaborators,
      elements,
      sections,
      machines,
    };

    if (formId) {
      data.lastEditedBy = session?.username?.toLocaleLowerCase() || "";
      data.lastEditedAt = moment().format("YYYY-MM-DD HH:mm:ss");
    }

    if (formId) {
      const validation =
        (state === LOCAL_NEW_STATE || state === LOCAL_UPDATE_STATE) && online;
      if (validation) {
        console.log('[handleOnSubmit] Sincronizando formulario pendiente...');
        data["state"] = state;
        const syncOk = await syncUpdatedForm(data);
        if (!syncOk) {
          console.error('[handleOnSubmit] ✗ syncUpdatedForm falló (formulario o imágenes)');
          setSaving(false);
          return swalWarningAlert(
            getTotalImageCount() > 5
              ? `Error al sincronizar. Este formulario tiene ${getTotalImageCount()} imágenes, intente reducir la cantidad o verifique su conexión.`
              : "Error al sincronizar. Verifique su conexión e intente nuevamente.",
            "Entendido"
          );
        }
        toast({icon: "success", title: "Formulario sincronizado y subido."});
      } else {
        console.log('[handleOnSubmit] Guardando imágenes para formulario existente');
        const result = await handleStoreImages(formId, dataImages);
        if (result !== true) {
          console.error('[handleOnSubmit] ✗ handleStoreImages falló:', result);
          setSaving(false);
          return swalWarningAlert(getImageErrorMsg(result, getTotalImageCount()), "Entendido");
        }
        console.log('[handleOnSubmit] ✓ Imágenes guardadas, actualizando formulario');
        await updateForm(formId, data);
        if (online) {
          toast({icon: "success", title: "Formulario actualizado."});
        } else {
          toast({icon: "warning", title: "Guardado localmente. Se subirá cuando te conectes."});
        }
      }
    } else {
      console.log('[handleOnSubmit] Guardando nuevo formulario con imágenes');
      const result = await storeImages(dataImages);
      if (result !== true) {
        console.error('[handleOnSubmit] ✗ storeImages falló para nuevo formulario:', result);
        setSaving(false);
        return swalWarningAlert(getImageErrorMsg(result, getTotalImageCount()), "Entendido");
      }
      console.log('[handleOnSubmit] ✓ Imágenes guardadas, guardando formulario');
      await storeForm(data);

      // Enviar correo de notificación para reportes de incidentes nuevos
      if (isIncidentReport && online) {
        try {
          const centerId = Number(values["p-1_2"]);
          const centerObj = centers.find(c => c.id === centerId);
          const instalacionNombre = centerObj?.title || "instalación no especificada";

          await fetch(`${API_URL}/send-email/incidente`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              to: session?.email || session?.username,
              nombre: session?.name || session?.username || "Usuario",
              idForm: newFormId,
              fecha: moment().format("DD/MM/YYYY"),
              instalacion: instalacionNombre,
              estado: "En proceso",
            }),
          });
          console.log('[handleOnSubmit] ✓ Correo de incidente enviado');
        } catch (emailErr) {
          console.error('[handleOnSubmit] ✗ Error enviando correo:', emailErr);
        }
      }

      if (online) {
        toast({icon: "success", title: "Formulario guardado."});
      } else {
        toast({icon: "warning", title: "Guardado localmente. Se subirá cuando te conectes."});
      }
    }

    if (session?.username) fetchSavedForms(session?.username);

    setSaving(false);
    navigate(-1);
  };

  const formik = useFormik({
    initialValues,
    onSubmit: values => {
      formik.setFieldValue("p-2_4", moment().format("HH:mm") || "");
      handleOnSubmit(values);
    },
  });

  const fetchUserDataByForm = _formId => {
    setLoading(true);

    Promise.all([fetchSavedForm(_formId), fetchImagesByForm(_formId)])
      .then(result => {
        const _form = result[0];
        const _images = result[1];

        const _findings = _form.hallazgos.map(finding => {
          const images = _.get(_images, `images.${finding.HallazgoId}`, []);
          return {...finding, images};
        });

        setFindings(_findings);
        setCommitments(_form.compromisos);
        setState(_form?.state);
        setOriginalUsername(_form?.username || null);
        setCollaborators(_form?.collaborators || []);
        setSections(_form?.sections || []);
        setMachines(_form?.machines || {});
        setSavedQuestions(_form?.Preguntas);

        _.forEach(_form.Preguntas, (question, key) => {
          formik.setFieldValue(key, question);
        });
      })
      .finally(() => setLoading(false));
  };

  const addFinding = newFinding => {
    setFindings(prev => {
      const _finding = _.maxBy(prev, el => el.HallazgoId);
      const maxId = _finding?.HallazgoId || 0;
      const _newFinding = {
        HallazgoId: maxId + 1,
        ...newFinding,
      };
      return [...prev, _newFinding];
    });
  };

  const removeFinding = async HallazgoId => {
    const _commitment = commitments.find(c => c.HallazgoId === HallazgoId);
    if (_commitment)
      return swalWarningAlert(
        "No se puede eliminar este hallazgo debido a que esta asociado a un compromiso.",
        "Ok"
      );

    const {isConfirmed} = await swalAlert(
      "¿Deseas eliminar este hallazgo?",
      null,
      "Eliminar",
      "Cancelar",
      COLOR_DANGER
    );
    if (isConfirmed) {
      const _findings = findings.filter(f => f.HallazgoId !== HallazgoId);
      setFindings(_findings);
    }
  };

  const openEditFinding = data => {
    setOpenFindings(true);
    setFinding(data);
  };

  const openPreviewFinding = data => {
    setOpenFindings(true);
    setIsPreviewFinding(true);
    setFinding(data);
  };

  const editFinding = (newData, HallazgoId) => {
    const _findings = findings.map(f => {
      let newFinding = f;
      if (f.HallazgoId === HallazgoId) newFinding = {...newFinding, ...newData};
      return newFinding;
    });
    setFindings(_findings);
  };

  const addCommitment = newCommitment => {
    setCommitments(prev => {
      const _commitment = _.maxBy(prev, el => el.idCompromiso);
      const maxId = _commitment?.idCompromiso || 0;
      const _newCommitment = {
        idCompromiso: maxId + 1,
        ...newCommitment,
      };
      return [...prev, _newCommitment];
    });
  };

  const removeCommitment = async idCompromiso => {
    const id = Number(idCompromiso);
    const {isConfirmed} = await swalAlert(
      "¿Deseas eliminar este compromiso?",
      null,
      "Eliminar",
      "Cancelar",
      COLOR_DANGER
    );
    if (!isConfirmed) return;
    const _commitments = commitments.filter(c => c.idCompromiso !== id);
    setCommitments([..._commitments]);
  };

  const openEditCommitment = data => {
    setOpenCommitments(true);
    setCommitment(data);
  };

  const openPreviewCommitment = data => {
    setOpenCommitments(true);
    setIsPreviewCommitment(true);
    setCommitment(data);
  };

  const editCommitment = (newData, idCompromiso) => {
    const _commitments = commitments.map(c => {
      if (c.idCompromiso === idCompromiso) return {...c, ...newData};
      return c;
    });
    setCommitments(_commitments);
  };

  const handleAddElement = () => {
    const e = {
      id: moment().unix() + _.random(0, 1000),
      name: "",
      desciption: "",
      state: "",
      comments: "",
    };
    setElements(prev => [...prev, e]);
  };

  const handleRemoveElement = id => {
    setElements(prev => {
      return prev.filter(e => e.id !== id);
    });
  };

  const handleAddCollaborator = () => {
    const coll = {
      id: moment().unix() + _.random(0, 1000),
      rut: "",
      name: "",
      state: "",
      comments: "",
      sections: [
        {id: moment().valueOf(), section: "", yn: "", observation: ""},
      ],
    };
    setCollaborators(prev => [...prev, coll]);
    if (form?.FormType === 8) setCollaboratorIndex(collaborators.length);
  };

  const handleRemoveCollaborator = id => {
    setCollaborators(prev => {
      const newColaborators = prev.filter(c => c.id !== id);
      return newColaborators;
    });
    setCollaboratorIndex(0);
  };

  const handleSetRut = event => {
    event.target.value = format(event.target.value, {dots: false});
    formik.handleChange(event);
  };

  const handleOnChangeCollaborators = (index, key, value) => {
    const val = key === "rut" ? format(value, {dots: false}) : value;
    const _collaborators = _.clone(collaborators);
    _collaborators[index][key] = val;

    if (key === "rut" && val.length >= 7 && form?.FormType !== 12) {
      const normalizeRut = r => (r || "").replace(/\./g, "").replace(/-/g, "").replace(/^0+/, "").toLowerCase().trim();
      const user = usersRef.current.find(u => normalizeRut(u.rut) === normalizeRut(val));
      if (user) {
        _collaborators[index].name = user.name || "";
        _collaborators[index].position = user.position || "";
      }
    }

    setCollaborators(_collaborators);
  };

  const handleOnChangeCollaboratorsSection = (index, secIndex, key, value) => {
    const _collaborators = _.clone(collaborators);
    _collaborators[index].sections[secIndex][key] = value;
    setCollaborators(_collaborators);
  };

  const handleOnChangeMachines = (index, key, value) => {
    const _machines = _.clone(machines);

    if (!_machines[index]) _machines[index] = {yesOrNo: "", comments: ""};
    _machines[index][key] = value;

    setMachines(_machines);
  };

  const handleOnChangeElements = (index, key, value) => {
    const _elements = _.clone(elements);
    _elements[index][key] = value;
    setElements(_elements);
  };

  const handleOnChangeSections = (index, key, value) => {
    const _sections = _.clone(sections);
    _sections[index][key] = value;
    setSections(_sections);
  };

  const handleOnChangeSectionItem = (index, itemIndex, key, value) => {
    const _sections = _.clone(sections);
    _sections[index][key][itemIndex] = value;
    setSections(_sections);
  };

  const handleRemoveSectionItem = (index, itemIndex, key) => {
    const _sections = _.clone(sections);
    _sections[index][key] = _.filter(
      _sections[index][key],
      (item, i) => i !== itemIndex
    );
    setSections(_sections);
  };

  const handleAddSectionItem = (index, key) => {
    const _sections = _.clone(sections);
    const items = _sections[index][key] || [];
    _sections[index][key] = [...items, ""];
    setSections(_sections);
  };

  const handleAddSection = () => {
    let sec = {
      id: moment().unix() + _.random(0, 1000),
      sectionName: "",
      evaluation: "",
      observations: "",
    };

    if (form?.FormType === 11 || form?.FormType === 12) {
      sec = {
        ...sec,
        tasksTitle: "",
        tasksItems: [""],
        dangers: [""],
        precautionaryMeasures: [""],
      };
    }

    setSections(prev => [...prev, sec]);
  };

  const handleAddSectionToCollaborator = () => {
    const collaboratorsAux = _.clone(collaborators);
    const sec = {
      id: moment().valueOf(),
      section: "",
      yn: "",
      observations: "",
    };
    const sectionsAux = collaboratorsAux[collaboratorIndex].sections;
    collaboratorsAux[collaboratorIndex].sections = [...sectionsAux, sec];
    setCollaborators(collaboratorsAux);
  };

  const handleRemoveSection = id => {
    setSections(prev => prev.filter(s => s.id !== id));
  };

  const handleRemoveCollaboratorSection = secId => {
    const collaboratorsAux = _.clone(collaborators);
    const sectionsAux = collaboratorsAux[collaboratorIndex].sections || [];
    collaboratorsAux[collaboratorIndex].sections = sectionsAux.filter(
      s => s.id !== secId
    );
    setCollaborators(collaboratorsAux);
  };

  const inlineImgLimit = 3;
  const globalImgLimit = 15;

  const getTotalImageCount = () => {
    const findingImgs = findings.reduce((acc, f) => acc + (f.images?.length || 0), 0);
    const pendingImgs = Object.values(incidentImages).reduce((acc, imgs) => acc + (imgs?.length || 0), 0);
    return findingImgs + pendingImgs;
  };

  const isGlobalImgLimitReached = () => getTotalImageCount() >= globalImgLimit;

  const inlineImgKey = (partA, partB) => `${partA}-${partB}`;

  const addInlineImage = (key, base64) => {
    if (isGlobalImgLimitReached()) {
      toast({ icon: "warning", title: `Límite de ${globalImgLimit} imágenes por formulario alcanzado. Reduzca la cantidad de imágenes para continuar.` });
      return;
    }
    setIncidentImages(prev => {
      const current = prev[key] || [];
      if (current.length >= inlineImgLimit) return prev;
      return { ...prev, [key]: [...current, base64] };
    });
  };

  const removeInlineImage = (key, index) => {
    setIncidentImages(prev => {
      const imgs = [...(prev[key] || [])];
      imgs.splice(index, 1);
      return { ...prev, [key]: imgs };
    });
  };

  const takeInlinePhoto = async (source, key) => {
    if (platform === "web") return;
    if ((incidentImages[key] || []).length >= inlineImgLimit) return;
    if (isGlobalImgLimitReached()) {
      toast({ icon: "warning", title: `Límite de ${globalImgLimit} imágenes por formulario alcanzado.` });
      return;
    }
    Camera.getPhoto({
      quality: 60,
      allowEditing: false,
      saveToGallery: false,
      resultType: CameraResultType.Base64,
      source,
      direction: CameraDirection.Rear,
    })
      .then(image => {
        const base64 = `data:image/${image.format};base64,${image.base64String}`;
        return base64ToBlob(base64);
      })
      .then(blob => imageCompressor(blob))
      .then(compressed => fileToBase64(compressed))
      .then(newBase64 => addInlineImage(key, newBase64));
  };

  const webInlineUpload = (files, key) => {
    if (platform !== "web") return;
    if ((incidentImages[key] || []).length >= inlineImgLimit) return;
    if (isGlobalImgLimitReached()) {
      toast({ icon: "warning", title: `Límite de ${globalImgLimit} imágenes por formulario alcanzado.` });
      return;
    }
    imageCompressor(files[0])
      .then(compressed => fileToBase64(compressed))
      .then(base64 => addInlineImage(key, base64));
  };

  const addInlineFinding = (imgKey, observacion, evaluacion) => {
    const trimmedObs = (observacion || "").trim();
    const categoryId = inlineCategories[imgKey] || "";
    if (!trimmedObs) {
      toast({ icon: "warning", title: "La observación es obligatoria." });
      return;
    }
    if (!isIncidentReport) {
      if (!evaluacion) {
        toast({ icon: "warning", title: "La evaluación es obligatoria." });
        return;
      }
      if (showCategory && !categoryId) {
        toast({ icon: "warning", title: "La categoría es obligatoria." });
        return;
      }
    }

    const imgs = incidentImages[imgKey] || [];
    const categoryObj = findingCategories.find(c => String(c.id) === String(categoryId));
    const findingData = {
      Hallazgo: isIncidentReport ? "INCIDENTE" : (categoryObj?.title || "Hallazgo"),
      Observacion: trimmedObs,
      images: imgs,
    };
    if (isIncidentReport) {
      const incidentCat = findingCategories.find(c => c.title === "INCIDENTE");
      if (incidentCat) findingData.CategoriaId = incidentCat.id;
    } else if (categoryId) {
      findingData.CategoriaId = categoryId;
    }
    if (!isIncidentReport && evaluacion) {
      findingData.Evaluacion = evaluacion;
    }
    addFinding(findingData);
    setIncidentImages(prev => ({ ...prev, [imgKey]: [] }));
    toast({ icon: "success", title: "Hallazgo agregado." });
  };

  const isJefatura = rol === "Jefatura" || (!rol && form?.Titulo?.includes("Jefatura"));
  const showCategory = !isJefatura;

  const renderCategorySelect = (imgKey) => {
    if (isIncidentReport || !showCategory) return null;
    return (
      <select
        className="form-select"
        value={inlineCategories[imgKey] || ""}
        onChange={e => setInlineCategories(prev => ({ ...prev, [imgKey]: e.target.value }))}
      >
        <option value="" hidden>Seleccione...</option>
        {findingCategories.map(cat => (
          <option key={cat.id} value={cat.id}>
            {cat.title}
          </option>
        ))}
      </select>
    );
  };

  const renderInlineActions = (imgKey, observacion, evaluacion) => {
    const imgs = incidentImages[imgKey] || [];
    const atLimit = imgs.length >= inlineImgLimit || isGlobalImgLimitReached();
    return (
      <div className="d-flex flex-wrap gap-1 justify-content-center align-items-center">
        {platform === "web" ? (
          <>
            <button
              type="button"
              className="btn bg-primary btn-sm text-white d-flex align-items-center"
              disabled={atLimit}
            >
              <label
                htmlFor={`inline-upload-${imgKey}`}
                className="d-flex align-items-center"
                style={{ cursor: atLimit ? "default" : "pointer" }}
              >
                <FontAwesomeIcon icon={faImages} />
                <span className="ms-1">Imagen</span>
              </label>
            </button>
            <input
              id={`inline-upload-${imgKey}`}
              type="file"
              accept="image/png,image/jpg,image/jpeg"
              onChange={e => webInlineUpload(e.target.files, imgKey)}
              hidden
            />
          </>
        ) : (
          <>
            <button
              type="button"
              className="btn bg-primary btn-sm text-white d-flex align-items-center"
              onClick={() => takeInlinePhoto(CameraSource.Camera, imgKey)}
              disabled={atLimit}
            >
              <FontAwesomeIcon icon={faCamera} />
              <span className="ms-1">Foto</span>
            </button>
            <button
              type="button"
              className="btn bg-primary btn-sm text-white d-flex align-items-center"
              onClick={() => takeInlinePhoto(CameraSource.Photos, imgKey)}
              disabled={atLimit}
            >
              <FontAwesomeIcon icon={faImages} />
              <span className="ms-1">Galería</span>
            </button>
          </>
        )}
        <button
          type="button"
          className="btn btn-success btn-sm text-white d-flex align-items-center"
          onClick={() => addInlineFinding(imgKey, observacion, evaluacion)}
        >
          <FontAwesomeIcon icon={faPlus} />
          <span className="ms-1">Hallazgo</span>
        </button>
        {imgs.length > 0 && (
          <div className="d-flex flex-wrap gap-1 mt-1 w-100">
            {imgs.map((img, idx) => (
              <div key={idx} className="position-relative" style={{ width: 50, height: 50 }}>
                <img
                  src={img}
                  alt={`img-${idx}`}
                  className="img-thumbnail"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
                <button
                  type="button"
                  className="btn btn-danger btn-sm position-absolute top-0 end-0 p-0"
                  style={{ width: 16, height: 16, fontSize: 9, lineHeight: 1 }}
                  onClick={() => removeInlineImage(imgKey, idx)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
            ))}
          </div>
        )}
        {atLimit && <small className={`w-100 ${isGlobalImgLimitReached() ? "text-danger" : "text-muted"}`}>{isGlobalImgLimitReached() ? `Límite total de ${globalImgLimit} imágenes alcanzado.` : `Máx. ${inlineImgLimit} imágenes.`}</small>}
      </div>
    );
  };

  const takePhoto = async (source, collaborator) => {
    if (platform === "web" || !online) return;

    console.log('[takePhoto] Iniciando captura de foto para colaborador:', collaborator.id);

    Camera.getPhoto({
      quality: 60,
      allowEditing: false,
      saveToGallery: false,
      resultType: CameraResultType.Base64,
      source,
      direction: CameraDirection.Rear,
    })

      .then(image => {
        console.log('[takePhoto] ✓ Foto capturada, formato:', image.format);
        const base64 = `data:image/${image.format};base64,${image.base64String}`;
        return base64ToBlob(base64);
      })
      .then(blob => {
        if (!blob) {
          console.error('[takePhoto] ✗ base64ToBlob retornó null');
          throw new Error('base64ToBlob failed');
        }
        const sizeInMB = (blob.size / 1024 / 1024).toFixed(2);
        console.log('[takePhoto] ✓ Blob creado (', sizeInMB, 'MB), comprimiendo...');
        return imageCompressor(blob);
      })
      .then(compressed => {
        if (!compressed) {
          console.error('[takePhoto] ✗ imageCompressor retornó null');
          throw new Error('imageCompressor failed');
        }
        const sizeInMB = (compressed.size / 1024 / 1024).toFixed(2);
        console.log('[takePhoto] ✓ Imagen comprimida (', sizeInMB, 'MB), convirtiendo a base64...');
        return fileToBase64(compressed);
      })
      .then(newBase64 => {
        if (!newBase64) {
          console.error('[takePhoto] ✗ fileToBase64 retornó null');
          throw new Error('fileToBase64 failed');
        }
        console.log('[takePhoto] ✓ Conversión completada, guardando en estado');
        const collaboratorsAux = collaborators.map(c => {
          if (c.id === collaborator.id) {
            c["CI"] = newBase64;
            c["dateTimeCI"] = moment().format("YYYY-MM-DD HH:mm:ss");
          }
          return c;
        });
        setCollaborators(collaboratorsAux);
      })
      .catch(error => {
        console.error('[takePhoto] ✗ ERROR en cadena de procesamiento:', error.message);
      });
  };

  const saveSignature = (collaborator, signature) => {
    const collaboratorsAux = collaborators.map(c => {
      if (c.id === collaborator.id) {
        c["signature"] = signature;
        c["dateTimeSignature"] = moment().format("YYYY-MM-DD HH:mm");
      }
      return c;
    });
    setCollaborators(collaboratorsAux);
  };

  const removeSignature = collaborator => {
    const collaboratorsAux = collaborators.map(c => {
      if (c.id === collaborator.id) {
        c["signature"] = null;
        c["dateTimeSignature"] = null;
      }
      return c;
    });
    setCollaborators(collaboratorsAux);
  };

  const saveCI = (event, collaborator) => {
    const file = event.target.files[0] || null;
    if (!file) return;

    console.log('[saveCI] Procesando archivo para colaborador:', collaborator.id, 'Archivo:', file.name, 'Tamaño:', (file.size / 1024 / 1024).toFixed(2), 'MB');

    imageCompressor(file)
      .then(compressed => {
        if (!compressed) {
          console.error('[saveCI] ✗ imageCompressor retornó null');
          throw new Error('imageCompressor failed');
        }
        console.log('[saveCI] ✓ Archivo comprimido, convirtiendo a base64...');
        return fileToBase64(compressed);
      })
      .then(image => {
        if (!image) {
          console.error('[saveCI] ✗ fileToBase64 retornó null');
          throw new Error('fileToBase64 failed');
        }
        console.log('[saveCI] ✓ Conversión completada, guardando en estado');
        const collaboratorsAux = collaborators.map(c => {
          if (c.id === collaborator.id) {
            c["CI"] = image;
            c["dateTimeCI"] = moment().format("YYYY-MM-DD HH:mm");
          }
          return c;
        });
        setCollaborators(collaboratorsAux);
      })
      .catch(error => {
        console.error('[saveCI] ✗ ERROR en procesamiento:', error.message);
      })
      .finally(() => {
        const input = document.getElementById(
          "form-upload-ci-" + collaborator.id
        );
        input.value = null;
      });
  };

  const removeCI = collaborator => {
    const input = document.getElementById("form-upload-ci-" + collaborator.id);
    input.value = null;

    const collaboratorsAux = collaborators.map(c => {
      if (c.id === collaborator.id) {
        c["CI"] = null;
        c["dateTimeCi"] = null;
      }
      return c;
    });
    setCollaborators(collaboratorsAux);
  };

  useEffect(() => {
    if (
      formsAD.length <= 0 ||
      formsAM.length <= 0 ||
      formsP.length <= 0 ||
      formsADM.length <= 0 ||
      !templateId
    )
      return;

    const forms = [...formsAD, ...formsAM, ...formsP, ...formsADM];
    const _form = forms.find(f => f.TemplateId.toString() === templateId);

     const _title = handleCleanTitle((_form?.Titulo || "").trim(), rol?.trim() || "")
      .replace("Inspector", "SSO")
      .replace("Jefatura", "Supervisor");
    setForm(_form);
    setAppTitle(_title);
  }, [formsAD, formsAM, formsP, templateId]);

  useEffect(() => {
    if (openFindings) return;
    setFinding(null);
    setIsPreviewFinding(false);
  }, [openFindings]);

  useEffect(() => {
    if (openCommitments) return;
    setIsPreviewCommitment(false);
    setCommitment(null);
  }, [openCommitments]);

  useEffect(() => {
    if (!form?.TemplateId) return;

    let values = {
      "p-1_1": "",
      "p-1_2": "",
      "p-1_3": "",
      "p-1_4": "",
      "p-1_5": "",
      "p-2_1": "",
      "p-2_2": "",
      "p-2_3": "",
      "p-2_4": "",
      "p-2_12": "",
      "p-5": "",
    };

    if (form?.FormType === 5) {
      values = {
        ...values,
        "p-2_5": "",
      };

      form.Acciones.forEach(action => {
        action.Preguntas.forEach(question => {
          const psnId = `psn-3_${action.Id}_${question.Id}`;
          const poId = `po-3_${action.Id}_${question.Id}`;

          values[psnId] = "3";
          values[poId] = "";
        });
      });
    }

    if (form?.FormType === 2 || form?.FormType === 4) {
      values = {
        ...values,
        "p-2_5": "",
        "p-2_6": "",
        "p-2_7": "",
        "p-2_8": "",
        "p-2_9": "",
        "p-2_10": "",
      };
    }

    if (form?.FormType === 1 || form?.FormType === 2 || form?.FormType === 7 || form?.FormType === 12) {
      (form.Acciones || []).forEach(action => {
        (action.Preguntas || []).forEach(question => {
          const psnId = `psn-3_${action.Id}_${question.Id}`;
          const poId = `po-3_${action.Id}_${question.Id}`;

          values[psnId] = "3";
          values[poId] = "";
        });
      });
    }

    if (form?.FormType === 6) {
      form.Acciones.forEach(action => {
        action.Preguntas.forEach(question => {
          const psnId = `psn-3_${action.Id}_${question.Id}`;
          const poId = `po-3_${action.Id}_${question.Id}`;

          values[psnId] = "3";
          values[poId] = "";
        });
      });
    }

    if (form?.FormType === 9) {
      values = {
        ...values,
        "p-2_6": "",
      };
    }

    if (form?.FormType === 12) {
      values = {
        ...values,
        "buceo-localizacion": "", "buceo-ejecucion": "", "buceo-tipoTrabajo": "",
        "buceo-descripcion": "", "buceo-supNombre": "", "buceo-supFono": "",
        "buceo-jefeNombre": "", "buceo-jefeFono": "", "buceo-capitanNombre": "", "buceo-capitanFono": "",
        "buceo-declaracionLeida": false, "buceo-observacionesRechazo": "",
      };
    }

    if (form?.FormType !== 11 && form?.FormType !== 12) {
      setSections([defaultSection]);
    }

    setInitialValues(values);
  }, [form]);

  useEffect(() => {
    if (formId) fetchUserDataByForm(formId);

    return () => {
      setInitialValues({});
      setCollaborators([
        {
          id: moment().unix() + _.random(0, 1000),
          rut: "",
          name: "",
          state: "",
          comments: "",
          sections: [
            {id: moment().valueOf(), section: "", yn: "", observation: ""},
          ],
        },
      ]);
      setElements([
        {
          id: moment().unix() + _.random(0, 1000),
          name: "",
          desciption: "",
          state: "",
          comments: "",
        },
      ]);
      setLoading(false);
    };
  }, []);

  useEffect(() => {
    // Obtener subusuarios de la sesión
    const userSubUsers = session?.subUsuarios || [];
    const freeInspectorField = form?.FormType === 11 || [15, 64, 66].includes(Number(templateId));
    const username = freeInspectorField ? "" : session?.username || "";

    // Si hay subusuarios, usar el primero. Si no, usar el username en minúsculas.
    const subUserToSet = freeInspectorField ? "" : (userSubUsers.length > 0 ? userSubUsers[0] : session?.username?.toLocaleLowerCase());
  
    // Establecer el valor en Formik
    formik.setFieldValue("p-1_3", subUserToSet);
    formik.setFieldValue("p-1_4", moment().format("YYYY-MM-DD"));
    formik.setFieldValue("p-2_3", moment().format("HH:mm"));
  }, [session, form?.FormType]);
  

  useEffect(() => {
    if (!formik.values["p-2_5"]) return;

    const machineId = Number(formik.values["p-2_5"]);
    const _questions = ssoQuestions.filter(q => q.machineId === machineId);
    setQuestionsMachine(_questions);
  }, [ssoQuestions, formik.values["p-2_5"]]);

  useEffect(() => {
    if (!form?.TemplateId) return;

    const applyUsers = (usersData) => {
      usersRef.current = usersData;
      const mapped = usersData
        .filter(user => user.profile !== 1)
        .map(user => ({
          value: user.email,
          label: user.name + (user.position ? ` - ${user.position}` : ""),
        }));
      mapped.sort((a, b) => a.label.localeCompare(b.label, 'es', { sensitivity: 'base' }));
      setResponsible(mapped);
    };

    // 1. Cargar cache local inmediatamente
    const cached = getLocal("sso_users_cache", null);
    if (cached) applyUsers(cached);

    // 2. Fetch online y actualizar cache
    if (navigator.onLine) {
      getUsers().then(usersData => {
        if (usersData?.length) {
          putLocal("sso_users_cache", usersData);
          applyUsers(usersData);
        }
      });
    }
  }, [form]);

  useEffect(() => {
    const areaId = _.get(formik, "values.p-1_1", null);
    const _centers = allCenters.filter(c => c.areaId === Number(areaId));
    setCenters(_centers);
  }, [formik.values["p-1_1"], allCenters]);

  useEffect(() => {
    if (areas.length !== 1) return;
    const area = areas[0];
    if (!area) return;
    formik.setFieldValue("p-1_1", area.id);
  }, [areas]);

  useEffect(() => {
    if (isJefatura) return;
    if (categories.length !== 1) return;
    const category = categories[0];
    if (!category) return;
    formik.setFieldValue("p-2_1", category.id);
  }, [categories]);

  useEffect(() => {
    if (form?.FormType !== 2 && form?.FormType !== 4) return;
    if (machineType.length !== 1) return;
    const machine = machineType[0];
    if (!machine) return;
    formik.setFieldValue("p-2_5", machine.id);
  }, [machineType, form]);

  useEffect(() => {
    if (form?.FormType !== 2 && form?.FormType !== 4) return;
    if (itemsMachine.length !== 1) return;
    const item = itemsMachine[0];
    if (!item) return;
    formik.setFieldValue("p-2_6", item.id);
  }, [itemsMachine, form]);

  useEffect(() => {
    if (form?.FormType !== 9) return;
    if (machinesSso.length !== 1) return;
    const machine = machinesSso[0];
    if (!machine) return;
    formik.setFieldValue("p-2_5", machine.id);
  }, [machinesSso, form]);

  useEffect(() => {
    let _actions = _.cloneDeep(form?.Acciones || []);
    if (formId) {
      _actions = _.cloneDeep(_actions).map(a => {
        a.Preguntas = (a.Preguntas || []).filter(q => {
          const yn = !!savedQuestions[`psn-${a.Id}-${q.Id}`];
          const ob = !!savedQuestions[`po-${a.Id}-${q.Id}`];
          return !q.deleted || yn || ob;
        });
        return a;
      });
      _actions = _.cloneDeep(_actions).filter(a => {
        return (
          !a.deleted ||
          a.Preguntas.some(q => {
            const yn = !!savedQuestions[`psn-${a.Id}-${q.Id}`];
            const ob = !!savedQuestions[`po-${a.Id}-${q.Id}`];
            return yn || ob;
          })
        );
      });
    } else {
      _actions = _actions.filter(a => !a.deleted);
      _actions = _actions.map(a => {
        a.Preguntas = (a.Preguntas || []).filter(q => !q.deleted);
        return a;
      });
    }
    setActions(_actions);
  }, [form?.Acciones, savedQuestions, formId]);
  
  const templateIdNumber = Number(templateId);
  const isIncidentReport = form?.Titulo?.includes("Reporte de Incidentes");
  const isObsConductas = [15, 64, 66].includes(templateIdNumber);
  return (
    <form onSubmit={formik.handleSubmit}>
      <FormSection title="I IDENTIFICACIÓN GENERAL" show={true}>
        <div className="row">
          <div className="col-12 col-md-3 mb-3">
            <label htmlFor="inputEmail4" className="form-label">
              <span className="fw-bolder me-2">1.</span> Área{" "}
              <h5 className="text-danger m-0 d-inline">*</h5>
            </label>
            <select
              className="form-select"
              name="p-1_1"
              value={formik.values["p-1_1"] || ""}
              onChange={formik.handleChange}
              required
            >
              <option value="" hidden>
                Seleccione...
              </option>
              {areas.map(area => (
                <option key={area.id} value={area.id}>
                  {area.title}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-3 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">2.</span> Instalación{" "}
              <h5 className="text-danger m-0 d-inline">*</h5>
            </label>
            <select
              className="form-select"
              name="p-1_2"
              value={formik.values["p-1_2"]}
              onChange={formik.handleChange}
              required
            >
              <option value="" hidden>
                Seleccione...
              </option>
              {centers.map(center => (
                <option key={center.id} value={center.id}>
                  {center.title}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-3 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">3.</span> Inspector
              <h5 className="text-danger m-0 d-inline">*</h5>
            </label>

            {session?.subUsuarios && session.subUsuarios.length > 0 ? (
              // Si hay subusuarios, siempre mostrar select
              <select
              name="p-1_3"
              className="form-select"
              value={formik.values["p-1_3"] || ""}
              onChange={(e) => {
                const selectedSubUser = e.target.value;
                formik.setFieldValue("p-1_3", selectedSubUser);
              }}
              required
            >
              {session.subUsuarios.map((subUser, index) => (
                <option key={index} value={subUser}>
                  {subUser}
                </option>
              ))}
            </select>
            ) : form?.FormType === 11 || isObsConductas ? (
              // Si NO hay subusuarios y el tipo es 11 o es Obs. Conductas: permitir escribir libremente
              <input
                type="text"
                className="form-control"
                name="p-1_3"
                value={formik.values["p-1_3"] || ""}
                onChange={formik.handleChange}
                placeholder="Ingresa un inspector..."
                required
              />
            ) : (
              // Si NO hay subusuarios y el tipo NO es 11: input deshabilitado
              <input
                type="email"
                className="form-control"
                name="p-1_3"
                value={formik.values["p-1_3"] || ""}
                onChange={formik.handleChange}
                disabled
                required
              />
            )}
          </div>
  
          <div className="col-12 col-md-3 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">4.</span> Fecha Registro{" "}
              <h5 className="text-danger m-0 d-inline">*</h5>
            </label>
            <input
              type="date"
              className="form-control"
              name="p-1_4"
              value={formik.values["p-1_4"] || ""}
              onChange={formik.handleChange}
              required
            />
          </div>

      {[7,8,11,33,1,2,75,76,68,77,12,16,19,20,69,86,87,88,89].includes(templateIdNumber) && (
        <div className="col-12 col-md-3 mb-3">
          <label className="form-label">
            <span className="fw-bolder me-2">5.</span> Nombre servicio{" "}
            <h5 className="text-danger m-0 d-inline">*</h5>
          </label>
          <input
            type="text"
            className="form-control"
            name="p-1_5"
            value={formik.values["p-1_5"] || ""}
            onChange={(e) =>
              formik.setFieldValue("p-1_5", e.target.value.toUpperCase())
            }
            placeholder="Ingresa un servicio..."
            required
            style={{ textTransform: "uppercase" }}
          />
        </div>
      )}

          {isIncidentReport && (
            <>
              <div className="col-6 col-md-2 mb-3">
                <label className="form-label">
                  <span className="fw-bolder me-2">5.</span>
                  Horario Inicio <h5 className="text-danger m-0 d-inline">*</h5>
                </label>
                <input
                  type="time"
                  className="form-control"
                  name="p-2_3"
                  value={formik.values["p-2_3"] || ""}
                  onChange={formik.handleChange}
                  required
                />
              </div>
              <div className="col-6 col-md-2 mb-3">
                <label className="form-label">
                  <span className="fw-bolder me-2">6.</span>
                  Horario Término
                </label>
                <input
                  type="time"
                  className="form-control"
                  name="p-2_4"
                  value={formik.values["p-2_4"] || ""}
                  onChange={formik.handleChange}
                  disabled={!formik.values["p-2_3"]}
                  min={formik.values["p-2_3"]}
                />
              </div>
            </>
          )}
        </div>
      </FormSection>

      <DialogFormSignature
        collaborator={collaboratorSignature}
        control={setCollaboratorSignature}
        save={saveSignature}
      />

      <FormSection title="II IDENTIFICACIÓN ESPECIFICA" show={!isIncidentReport && form?.FormType !== 12}>
        <div className="row">
          {form?.FormType !== 11 && (
            <>
              {!isJefatura && (
                <div className="col-12 col-md-3 mb-3">
                  <label className="form-label">
                    <span className="fw-bolder me-2">1.</span> Alcance{" "}
                    <h5 className="text-danger m-0 d-inline">*</h5>
                  </label>
                  <select
                    className="form-select"
                    name="p-2_1"
                    value={formik.values["p-2_1"] || ""}
                    onChange={formik.handleChange}
                    required
                  >
                    <option value="" hidden>
                      Seleccione...
                    </option>
                    {categories.map(category => (
                      <option key={category.id} value={category.id}>
                        {category.title}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="col-12 col-md-5 mb-3">
                <label className="form-label">
                  <span className="fw-bolder me-2">2.</span> Descripción de la
                  actividad observada{" "}
                  <h5 className="text-danger m-0 d-inline">*</h5>
                </label>
                <textarea
                  type="time"
                  className="form-control"
                  name="p-2_2"
                  value={formik.values["p-2_2"] || ""}
                  onChange={formik.handleChange}
                  min={formik.values["p-2_2"]}
                  placeholder="Escriba aquí."
                  required
                />
              </div>
            </>
          )}

          <div className="col-6 col-md-2 mb-3">
            <label className="form-label">
              {form?.FormType === 11 ? (
                <span className="fw-bolder me-2">1. </span>
              ) : (
                <span className="fw-bolder me-2">3. </span>
              )}
              Horario Inicio <h5 className="text-danger m-0 d-inline">*</h5>
            </label>
            <input
              type="time"
              className="form-control"
              name="p-2_3"
              value={formik.values["p-2_3"] || ""}
              onChange={formik.handleChange}
              required
            />
          </div>

          <div className="col-6 col-md-2 mb-3">
            <label className="form-label">
              {form?.FormType === 11 ? (
                <span className="fw-bolder me-2">2. </span>
              ) : (
                <span className="fw-bolder me-2">4. </span>
              )}
              Horario Término
            </label>
            <input
              type="time"
              className="form-control"
              name="p-2_4"
              value={formik.values["p-2_4"] || ""}
              onChange={formik.handleChange}
              disabled={!formik.values["p-2_3"]}
              min={formik.values["p-2_3"]}
            />
          </div>

          {[7,8,1,75,76,77,19,20,16].includes(templateIdNumber) && (
          <div className="col-12 col-md-3 mb-3">
          <label className="form-label">
              <span className="fw-bolder me-2"></span>Nombre de embarcación{" "}
              <h5 className="text-danger m-0 d-inline">*</h5>
            </label>
          <input
                type="text"
                className="form-control"
                name="p-2_12"
                value={formik.values["p-2_12"] || ""}
                  onChange={(e) =>
                formik.setFieldValue("p-2_12", e.target.value.toUpperCase())
                }
                placeholder="Ingresa una embarcación..."
                required
                style={{ textTransform: "uppercase" }}
              />
          </div>
          )}
          {form?.FormType === 5 && (
            <div className="col-12 col-md-3 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">5.</span> Habitable
                <h5 className="text-danger m-0 d-inline"> *</h5>
              </label>
              <select
                className="form-select"
                name="p-2_5"
                value={formik.values["p-2_5"] || ""}
                onChange={formik.handleChange}
                required
              >
                <option value="" hidden>
                  Seleccione...
                </option>
              </select>
            </div>
          )}
        </div>

        <FormSubSection
          title={
            <>
              {"Identificación maquinaria o instrumento"}
              <h5 className="text-danger m-0 d-inline"> *</h5>
            </>
          }
          show={form?.FormType === 2 || form?.FormType === 4}
        >
          <div className="row">
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">5.</span> Tipo Maq{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <select
                className="form-select"
                name="p-2_5"
                value={formik.values["p-2_5"] || ""}
                onChange={formik.handleChange}
                required
              >
                <option value="" hidden>
                  Seleccione...
                </option>
                {machineType.map(mt => (
                  <option key={mt.id} value={mt.id}>
                    {mt.title}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">6.</span> Item{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <select
                className="form-select"
                name="p-2_6"
                value={formik.values["p-2_6"] || ""}
                onChange={formik.handleChange}
                required
              >
                <option value="" hidden>
                  Seleccione...
                </option>
                {itemsMachine.map(im => (
                  <option key={im.id} value={im.id}>
                    {im.title}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">7.</span> Matrícula{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <input
                type="text"
                className="form-control"
                name="p-2_7"
                value={formik.values["p-2_7"] || ""}
                onChange={formik.handleChange}
                required
              />
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">8.</span> Marca{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <input
                type="text"
                className="form-control"
                name="p-2_8"
                value={formik.values["p-2_8"] || ""}
                onChange={formik.handleChange}
                required
              />
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">9.</span> Modelo{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <input
                type="text"
                className="form-control"
                name="p-2_9"
                value={formik.values["p-2_9"] || ""}
                onChange={formik.handleChange}
                required
              />
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">10.</span> Capacidad{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <input
                type="text"
                className="form-control"
                name="p-2_10"
                value={formik.values["p-2_10"] || ""}
                onChange={formik.handleChange}
                required
              />
            </div>
          </div>
        </FormSubSection>

        <FormSubSection
          title="Información colaboradores"
          show={form?.FormType === 7 || form?.FormType === 8}
          action={() => handleAddCollaborator()}
          actionContent={
            <>
              <FontAwesomeIcon icon={faPlus} />
              <span className="ms-2 d-none d-md-block">
                Agregar colaborador
              </span>
            </>
          }
        >
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Rut</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Puesto del trabajador observado</th>
                  <th scope="col">Comentarios</th>
                  <th scope="col">Acción</th>
                </tr>
              </thead>
              <tbody>
                {collaborators.map((collaborator, index) => (
                  <tr key={collaborator.id}>
                    <th scope="row">
                      <div
                        className="d-flex align-items-center"
                        style={{height: 38}}
                      >
                        {form?.FormType === 8 ? (
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="collaborators"
                              id={"check-coll-" + index}
                              value={index}
                              checked={collaboratorIndex === index}
                              onChange={() => setCollaboratorIndex(index)}
                            />

                            <label
                              className="form-check-label ms-2"
                              htmlFor={"check-coll-" + index}
                            >
                              {index + 1}
                            </label>
                          </div>
                        ) : (
                          <span>{index + 1}</span>
                        )}
                      </div>
                    </th>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={collaborators[index]?.rut}
                        onChange={({target}) =>
                          handleOnChangeCollaborators(
                            index,
                            "rut",
                            target.value
                          )
                        }
                        style={{minWidth: 150}}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={collaborators[index]?.name}
                        onChange={({target}) =>
                          handleOnChangeCollaborators(
                            index,
                            "name",
                            target.value
                          )
                        }
                        style={{minWidth: 150}}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={collaborators[index]?.position}
                        onChange={({target}) =>
                          handleOnChangeCollaborators(
                            index,
                            "position",
                            target.value
                          )
                        }
                        style={{minWidth: 100}}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={collaborators[index]?.comments}
                        onChange={({target}) =>
                          handleOnChangeCollaborators(
                            index,
                            "comments",
                            target.value
                          )
                        }
                        style={{minWidth: 150}}
                      />
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() =>
                          handleRemoveCollaborator(collaborator.id)
                        }
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </FormSubSection>

        <FormSubSection
          title="Asistencia"
          show={form?.FormType === 11}
          action={() => handleAddCollaborator()}
          actionContent={
            <>
              <FontAwesomeIcon icon={faPlus} />
              <span className="ms-2 d-none d-md-block">
                Agregar colaborador
              </span>
            </>
          }
        >
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Rut</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Puesto del trabajador</th>
                  {/*<th scope="col">CI</th>*/}
                  <th scope="col">Firma</th>
                  <th scope="col">Acción</th>
                </tr>
              </thead>
              <tbody>
                {collaborators.map((collaborator, index) => (
                  <tr key={collaborator.id}>
                    <th scope="row">
                      <div
                        className="d-flex align-items-center"
                        style={{height: 38}}
                      >
                        <span>{index + 1}</span>
                      </div>
                    </th>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={collaborators[index]?.rut}
                        onChange={({target}) =>
                          handleOnChangeCollaborators(
                            index,
                            "rut",
                            target.value
                          )
                        }
                        style={{minWidth: 100}}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={collaborators[index]?.name}
                        onChange={({target}) =>
                          handleOnChangeCollaborators(
                            index,
                            "name",
                            target.value
                          )
                        }
                        style={{minWidth: 150}}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={collaborators[index]?.position}
                        onChange={({target}) =>
                          handleOnChangeCollaborators(
                            index,
                            "position",
                            target.value
                          )
                        }
                        style={{minWidth: 80}}
                      />
                    </td>
                   {/*   <td>
                    <div className="d-flex align-items-center">
                        {platform === "web" && (
                          <>
                            <label
                              htmlFor={"form-upload-ci-" + collaborator.id}
                              className="btn bg-primary text-white fs-6 me-auto text-nowrap"
                            >
                              <FontAwesomeIcon
                                icon={faIdCard}
                                className="me-2"
                              />
                              CI
                            </label>
                            <input
                              type="file"
                              id={"form-upload-ci-" + collaborator.id}
                              onChange={event => saveCI(event, collaborator)}
                              accept="image/png, image/jpeg, image/jpg"
                              hidden
                            />
                          </>
                        )}
                        {platform !== "web" && (
                          <button
                            type="button"
                            className="btn bg-primary text-white fs-6 me-1 text-nowrap"
                            onClick={() =>
                              takePhoto(CameraSource.Camera, collaborator)
                            }
                            disabled={!online}
                          >
                            <FontAwesomeIcon icon={faCamera} className="me-2" />
                            Tomar foto
                          </button>
                        )}
                        {collaborator["CI"] && (
                          <button
                            type="button"
                            className="btn bg-danger text-white fs-6 me-auto ms-1"
                            onClick={() => removeCI(collaborator)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        )}
                      </div>
                    </td>*/}
                    <td>
                      <div className="d-flex align-items-center">
                        <button
                          type="button"
                          className="btn bg-primary text-white fs-6 me-auto text-nowrap"
                          onClick={() => setCollaboratorSignature(collaborator)}
                        >
                          <FontAwesomeIcon icon={faPenClip} className="me-2" />
                          Firma
                        </button>
                        {collaborator["signature"] && (
                          <button
                            type="button"
                            className="btn bg-danger text-white fs-6 me-auto ms-1"
                            onClick={() => removeSignature(collaborator)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        )}
                      </div>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() =>
                          handleRemoveCollaborator(collaborator.id)
                        }
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </FormSubSection>

        <FormSubSection
          title={
            <>
              {"Identificación maquinaria o instrumento"}{" "}
              <h5 className="text-danger m-0 d-inline">*</h5>
            </>
          }
          show={form?.FormType === 9}
        >
          <div className="row">
            <div className="col-12 col-md-4">
              <select
                className="form-select"
                name="p-2_5"
                value={formik.values["p-2_5"]}
                onChange={formik.handleChange}
                required
              >
                <option value="" hidden>
                  Seleccione...
                </option>
                {machinesSso.map(mach => (
                  <option key={mach.id} value={mach.id}>
                    {mach.title}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </FormSubSection>

        <FormSubSection title="Conductor" show={form?.FormType === 10}>
          <div className="row">
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">5.</span> Nombre conductor{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <input
                type="text"
                className="form-control"
                name="p-2_5"
                value={formik.values["p-2_5"] || ""}
                onChange={formik.handleChange}
                required
              />
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">6.</span> Rut{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <input
                type="text"
                className="form-control"
                name="p-2_6"
                value={formik.values["p-2_6"] || ""}
                onChange={handleSetRut}
                required
              />
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">7.</span> Licencia al día{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <select
                className="form-select"
                name="p-2_7"
                value={formik.values["p-2_7"] || ""}
                onChange={formik.handleChange}
                required
              >
                <option value="" hidden>
                  Seleccione...
                </option>
                <option value="1">Si</option>
                <option value="2">No</option>
              </select>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">8.</span> Permiso de
                circulación <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <select
                className="form-select"
                name="p-2_8"
                value={formik.values["p-2_8"] || ""}
                onChange={formik.handleChange}
                required
              >
                <option value="" hidden>
                  Seleccione...
                </option>
                <option value="1">Si</option>
                <option value="2">No</option>
              </select>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">9.</span> Seguro obligatorio{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <select
                className="form-select"
                name="p-2_9"
                value={formik.values["p-2_9"] || ""}
                onChange={formik.handleChange}
                required
              >
                <option value="" hidden>
                  Seleccione...
                </option>
                <option value="1">Si</option>
                <option value="2">No</option>
              </select>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">10.</span> Padrón{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <select
                className="form-select"
                name="p-2_10"
                value={formik.values["p-2_10"] || ""}
                onChange={formik.handleChange}
                required
              >
                <option value="" hidden>
                  Seleccione...
                </option>
                <option value="1">Si</option>
                <option value="2">No</option>
              </select>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <label className="form-label">
                <span className="fw-bolder me-2">11.</span> Permiso del Min{" "}
                <h5 className="text-danger m-0 d-inline">*</h5>
              </label>
              <select
                className="form-select"
                name="p-2_11"
                value={formik.values["p-2_11"] || ""}
                onChange={formik.handleChange}
                required
              >
                <option value="" hidden>
                  Seleccione...
                </option>
                <option value="1">Si</option>
                <option value="2">No</option>
              </select>
            </div>
          </div>
        </FormSubSection>
      </FormSection>

      <FormSection title="III DETALLE" show={form?.FormType === 11}>
        <div className="row d-none d-md-flex">
          <div className="col-4">
            <h6 className="text-center">Tareas y Trabajos a ejecutar</h6>
          </div>
          <div className="col-4">
            <h6 className="text-center">Identificación de Peligros</h6>
          </div>
          <div className="col-4">
            <h6 className="text-center">Medidas Preventivas</h6>
          </div>
        </div>

        {_.map(actions, (action, indexA) => (
          <div key={action.Id + indexA} className="row mt-4">
            {_.map(action.Preguntas, (question, indexQ) => (
              <div
                key={question.Id + indexQ}
                className="col-12 mb-4 border-bottom"
              >
                <div className="row">
                  <div className="col-12 col-md-4">
                    <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                      Tareas y Trabajos a ejecutar
                    </label>
                    <p className="m-0">{question?.Tareas?.Titulo}</p>
                    <ul className="fs-6">
                      {_.map(question?.Tareas?.Items, (item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                      Identificación de Peligros
                    </label>
                    <ul className="fs-6">
                      {_.map(question?.Peligros, (danger, i) => (
                        <li key={i}>{danger}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                      Medidas Preventivas
                    </label>
                    <ul className="fs-6">
                      {_.map(question?.Medidas, (preventiveMeasure, i) => (
                        <li key={i}>{preventiveMeasure}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}

        <div className="row mb-4 d-flex">
          <div className="col-6 my-auto">
            <h6 className="text-blue-cermaq">Otros</h6>
          </div>

          <div className="col-6 my-auto">
            <button
              type="button"
              className="btn bg-primary text-white ms-auto d-flex align-items-center"
              onClick={() => handleAddSection()}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span className="ms-2 d-none d-md-block">Agregar sección</span>
            </button>
          </div>
        </div>

        {sections.map((sec, index) => (
          <div key={sec.id} className="row mb-4 border-bottom">
            <div className="col-12 col-md-3 mb-2">
              {/* <label className="form-label my-2">
                Tareas y Trabajos a ejecutar
              </label> */}
              {/* <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                Tareas y Trabajos a ejecutar
              </label> */}
              {/* <input
                type="text"
                className="form-control mb-2"
                value={sections[index]?.tasksTitle || ""}
                onChange={({target}) =>
                  handleOnChangeSections(index, "tasksTitle", target.value)
                }
                placeholder="Ingresa titulo de tarea o trabajo..."
              /> */}
              <ul className="p-0" style={{listStyle: "none"}}>
                {_.map(sections[index]?.tasksItems, (item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className="d-flex align-items-center mb-2"
                  >
                    <button
                      type="button"
                      className="btn btn-danger btn-sm me-2"
                      disabled={sections[index]?.tasksItems?.length < 2}
                      onClick={() =>
                        handleRemoveSectionItem(index, itemIndex, "tasksItems")
                      }
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <textarea
                      rows="1"
                      className="form-control"
                      placeholder="Ingresa tarea o trabajo..."
                      value={item}
                      onChange={({target}) =>
                        handleOnChangeSectionItem(
                          index,
                          itemIndex,
                          "tasksItems",
                          target.value
                        )
                      }
                    />
                  </li>
                ))}
                <li className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn bg-primary text-white d-flex align-items-center justify-content-center btn-sm w-100"
                    onClick={() => handleAddSectionItem(index, "tasksItems")}
                  >
                    <FontAwesomeIcon icon={faAdd} />
                    <span className="ms-3">Tarea o trabajo</span>
                  </button>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-4 mb-2">
              <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                Identificación de Peligros
              </label>
              <ul className="p-0" style={{listStyle: "none"}}>
                {_.map(sections[index]?.dangers, (item, itemIndex) => (
                  <li
                    key={itemIndex}
                    className="d-flex align-items-center mb-2"
                  >
                    <button
                      type="button"
                      className="btn btn-danger btn-sm me-2"
                      disabled={sections[index]?.dangers?.length < 2}
                      onClick={() =>
                        handleRemoveSectionItem(index, itemIndex, "dangers")
                      }
                    >
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <textarea
                      rows="1"
                      className="form-control"
                      placeholder="Ingresa peligro..."
                      value={item}
                      onChange={({target}) =>
                        handleOnChangeSectionItem(
                          index,
                          itemIndex,
                          "dangers",
                          target.value
                        )
                      }
                    />
                  </li>
                ))}
                <li className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn bg-primary text-white d-flex align-items-center justify-content-center btn-sm w-100"
                    onClick={() => handleAddSectionItem(index, "dangers")}
                  >
                    <FontAwesomeIcon icon={faAdd} />
                    <span className="ms-3">Peligro</span>
                  </button>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-4 mb-2">
              <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                Medidas Preventivas
              </label>
              <ul className="p-0" style={{listStyle: "none"}}>
                {_.map(
                  sections[index]?.precautionaryMeasures,
                  (item, itemIndex) => (
                    <li
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                    >
                      <button
                        type="button"
                        className="btn btn-danger btn-sm me-2"
                        disabled={
                          sections[index]?.precautionaryMeasures?.length < 2
                        }
                        onClick={() =>
                          handleRemoveSectionItem(
                            index,
                            itemIndex,
                            "precautionaryMeasures"
                          )
                        }
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                      <textarea
                        rows="1"
                        className="form-control"
                        placeholder="Ingresa medida preventiva..."
                        value={item}
                        onChange={({target}) =>
                          handleOnChangeSectionItem(
                            index,
                            itemIndex,
                            "precautionaryMeasures",
                            target.value
                          )
                        }
                      />
                    </li>
                  )
                )}
                <li className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn bg-primary text-white d-flex align-items-center justify-content-center btn-sm w-100"
                    onClick={() =>
                      handleAddSectionItem(index, "precautionaryMeasures")
                    }
                  >
                    <FontAwesomeIcon icon={faAdd} />
                    <span className="ms-3">Medida preventiva</span>
                  </button>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-1 mb-2 d-flex">
              <button
                type="button"
                className="btn btn-danger d-flex align-items-center justify-content-center w-100 mb-auto"
                onClick={() => handleRemoveSection(sec.id)}
              >
                <FontAwesomeIcon icon={faXmark} />
                <span className="d-block d-md-none ms-3">Eliminar</span>
              </button>
            </div>
          </div>
        ))}
      </FormSection>

      <FormSection
        title="III DETALLE INSPECCIÓN"
        show={
          (form?.FormType === 1 ||
          form?.FormType === 2 ||
          form?.FormType === 7 ||
          form?.FormType === 10) && !isIncidentReport
        }
      >
        <div className="row d-none d-md-flex">
          <div className={showCategory ? "col-3" : "col-4"}>
            <h6 className="text-center">
              {form?.FormType === 7 ? "Preguntas" : "Conceptos"}
            </h6>
          </div>
          <div className={showCategory ? "col-2" : "col-3"}>
            <h6 className="text-center">Evaluación</h6>
          </div>
          {showCategory && (
            <div className="col-2">
              <h6 className="text-center">Categoría</h6>
            </div>
          )}
          <div className="col-2">
            <h6 className="text-center">Hallazgos</h6>
          </div>
          <div className="col-3">
            <h6 className="text-center">Acciones</h6>
          </div>
        </div>

        {_.map(actions.filter(a => !a.Preguntas?.some(q => q.Tareas)), (action, indexA) => (
          <div key={action.Id + indexA} className="row">
            <div className="col-12">
              <div className="border-top mt-2 mb-3">
                <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
              </div>
            </div>
            {_.map(action.Preguntas, (question, indexQ) => (
              <div key={question.Id + indexQ} className="col-12 mb-4">
                <div className="row">
                  <div className={`col-12 ${showCategory ? "col-md-3" : "col-md-4"}`}>
                    <label className="form-label d-block d-md-none">
                      {form?.FormType === 7 ? "Pregunta" : "Concepto"}
                    </label>
                    <span className="fw-bolder me-2">
                      {indexA + 1}.{indexQ + 1}.
                    </span>
                    {question.Titulo}
                  </div>
                  <div className={`col-12 ${showCategory ? "col-md-2" : "col-md-3"}`}>
                    <label className="form-label mt-3 d-block d-md-none">
                      Evaluación
                    </label>
                    <select
                      className="form-select"
                      name={`psn-${action.Id}-${question.Id}`}
                      value={formik.values[`psn-${action.Id}-${question.Id}`] || ""}
                      onChange={formik.handleChange}
                    >
                      <option value="" hidden>Seleccione...</option>
                      {questions.map(q => (
                        <option key={q.id} value={q.id}>
                          {q.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  {showCategory && (
                  <div className="col-12 col-md-2">
                    <label className="form-label mt-3 d-block d-md-none">
                      Categoría
                    </label>
                    {renderCategorySelect(inlineImgKey(action.Id, question.Id))}
                  </div>
                  )}
                  <div className="col-12 col-md-2">
                    <label className="form-label mt-3 d-block d-md-none">
                      Hallazgos
                    </label>
                    <textarea
                      rows="2"
                      className="form-control"
                      name={`po-${action.Id}-${question.Id}`}
                      value={
                        formik.values[`po-${action.Id}-${question.Id}`] || ""
                      }
                      onChange={formik.handleChange}
                      placeholder="Escriba aquí."
                    />
                  </div>
                  <div className="col-12 col-md-3 my-2 my-md-0">
                    {renderInlineActions(
                      inlineImgKey(action.Id, question.Id),
                      formik.values[`po-${action.Id}-${question.Id}`] || "",
                      formik.values[`psn-${action.Id}-${question.Id}`] || ""
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </FormSection>

      <FormSection
        title="II DETALLE INSPECCIÓN"
        show={isIncidentReport}
      >
        <div className="row d-none d-md-flex">
          <div className="col-5">
            <h6 className="text-center">Conceptos</h6>
          </div>
          <div className="col-4">
            <h6 className="text-center">Hallazgos</h6>
          </div>
          <div className="col-3">
            <h6 className="text-center">Acciones</h6>
          </div>
        </div>

        {_.map(actions, (action, indexA) => {
          const lesionQuestion = action.Preguntas?.find(q =>
            q.Titulo?.toLowerCase().includes("lesión") || q.Titulo?.toLowerCase().includes("lesion")
          );
          const otherQuestions = action.Preguntas?.filter(q =>
            !(q.Titulo?.toLowerCase().includes("lesión") || q.Titulo?.toLowerCase().includes("lesion"))
          ) || [];

          return (
            <div key={action.Id + indexA} className="row">
              <div className="col-12">
                <div className="border-top mt-2 mb-3">
                  <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
                </div>
              </div>

              {lesionQuestion && (
                <div className="col-12 mb-4">
                  <div className="row">
                    <div className="col-12 col-md-5">
                      <label className="form-label d-block d-md-none">
                        Concepto
                      </label>
                      <span className="fw-bolder me-2">
                        {indexA + 1}.1.
                      </span>
                      {lesionQuestion.Titulo}
                    </div>
                    <div className="col-12 col-md-4">
                      <select
                        className="form-select"
                        name={`psn-${action.Id}-${lesionQuestion.Id}`}
                        value={formik.values[`psn-${action.Id}-${lesionQuestion.Id}`] || ""}
                        onChange={formik.handleChange}
                      >
                        <option value="" hidden>Seleccione...</option>
                        {questions
                          .filter(q => q.title !== "Parcial")
                          .map(q => (
                            <option key={q.id} value={q.id}>
                              {q.title}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-12 col-md-3 my-2 my-md-0"></div>
                  </div>
                </div>
              )}

              {_.map(otherQuestions, (question, indexQ) => (
                <div key={question.Id + indexQ} className="col-12 mb-4">
                  <div className="row">
                    <div className="col-12 col-md-5">
                      <label className="form-label d-block d-md-none">
                        Concepto
                      </label>
                      <span className="fw-bolder me-2">
                        {indexA + 1}.{lesionQuestion ? indexQ + 2 : indexQ + 1}.
                      </span>
                      {question.Titulo}
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label mt-3 d-block d-md-none">
                        Hallazgos
                      </label>
                      <textarea
                        rows="2"
                        className="form-control"
                        name={`po-${action.Id}-${question.Id}`}
                        value={
                          formik.values[`po-${action.Id}-${question.Id}`] || ""
                        }
                        onChange={formik.handleChange}
                        placeholder="Escriba aquí."
                      />
                    </div>
                    <div className="col-12 col-md-3 my-2 my-md-0">
                      {renderInlineActions(
                        inlineImgKey(action.Id, question.Id),
                        formik.values[`po-${action.Id}-${question.Id}`] || ""
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      </FormSection>

      <FormSection
        title="III DETALLE INSPECCIÓN"
        show={form?.FormType === 3 || form?.FormType === 4}
        action={() => handleAddSection()}
        actionContent={
          <>
            <FontAwesomeIcon icon={faPlus} />
            <span className="ms-2 d-none d-md-block">Agregar sección</span>
          </>
        }
      >
        <div className="row d-none d-md-flex">
          <div className={showCategory ? "col-2" : "col-3"}>
            <h6 className="text-center">Conceptos</h6>
          </div>
          <div className={showCategory ? "col-2" : "col-3"}>
            <h6 className="text-center">Evaluación</h6>
          </div>
          {showCategory && (
            <div className="col-2">
              <h6 className="text-center">Categoría</h6>
            </div>
          )}
          <div className="col-2">
            <h6 className="text-center">Hallazgos</h6>
          </div>
          <div className="col-3">
            <h6 className="text-center">Acciones</h6>
          </div>
          <div className="col-1">
            <h6 className="text-center"></h6>
          </div>
        </div>
        {sections.map((sec, index) => (
          <div key={sec.id} className="row">
            <div className="col-12">
              <div className="border-top mt-2 mb-3">
                <h6 className="text-blue-cermaq mt-3">
                  Nombre sección {index + 1}
                </h6>
              </div>
            </div>
            <div className={`col-12 ${showCategory ? "col-md-2" : "col-md-3"} mb-2`}>
              <label className="form-label d-block d-md-none">Conceptos</label>
              <textarea
                rows="2"
                className="form-control"
                placeholder="Escriba aquí."
                value={sections[index]?.sectionName || ""}
                onChange={({target}) =>
                  handleOnChangeSections(index, "sectionName", target.value)
                }
              />
            </div>
            <div className={`col-12 ${showCategory ? "col-md-2" : "col-md-3"} mb-2`}>
              <label className="form-label d-block d-md-none">Evaluación</label>
              <select
                className="form-select"
                value={sections[index]?.evaluation || ""}
                onChange={({target}) =>
                  handleOnChangeSections(index, "evaluation", target.value)
                }
              >
                <option value="" hidden>Seleccione...</option>
                {questions.map(question => (
                  <option key={question.id} value={question.id}>
                    {question.title}
                  </option>
                ))}
              </select>
            </div>
            {showCategory && (
            <div className="col-12 col-md-2 mb-2">
              <label className="form-label d-block d-md-none">Categoría</label>
              {renderCategorySelect(inlineImgKey("sec", sec.id))}
            </div>
            )}
            <div className="col-12 col-md-2 mb-2">
              <label className="form-label d-block d-md-none">
                Hallazgos
              </label>
              <textarea
                rows="2"
                className="form-control"
                placeholder="Escriba aquí."
                value={sections[index]?.observations || ""}
                onChange={({target}) =>
                  handleOnChangeSections(index, "observations", target.value)
                }
              />
            </div>
            <div className="col-12 col-md-3 mb-2">
              {renderInlineActions(
                inlineImgKey("sec", sec.id),
                sections[index]?.observations || "",
                sections[index]?.evaluation || ""
              )}
            </div>
            <div className="col-12 col-md-1 mb-2">
              <button
                type="button"
                className="btn btn-danger d-flex align-items-center justify-content-center w-100"
                onClick={() => handleRemoveSection(sec.id)}
              >
                <FontAwesomeIcon icon={faXmark} />
                <span className="d-block d-md-none ms-3">Eliminar</span>
              </button>
            </div>
          </div>
        ))}
      </FormSection>

      <FormSection title="III DETALLE INSPECCIÓN" show={form?.FormType === 5}>
        <div className="row d-none d-md-flex">
          <div className={showCategory ? "col-1" : "col-2"}>
            <h6 className="text-center">Cantidad</h6>
          </div>
          <div className="col-2">
            <h6 className="text-center">Descripción</h6>
          </div>
          <div className="col-2">
            <h6 className="text-center">Ubicación</h6>
          </div>
          <div className={showCategory ? "col-1" : "col-2"}>
            <h6 className="text-center">Evaluación</h6>
          </div>
          {showCategory && (
            <div className="col-1">
              <h6 className="text-center">Categoría</h6>
            </div>
          )}
          <div className="col-2">
            <h6 className="text-center">Hallazgos</h6>
          </div>
          <div className="col-3">
            <h6 className="text-center">Acciones</h6>
          </div>
        </div>
        {_.map(actions, (action, indexA) => (
          <div key={action.Id + indexA} className="row">
            <div className="col-12">
              <div className="border-top mt-2 mb-3">
                <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
              </div>
            </div>

            {_.map(action.Preguntas, (question, indexQ) => (
              <div key={question.Id + indexQ} className="col-12 mb-4">
                <div className="row">
                  <div className={`fw-bolder col-12 ${showCategory ? "col-md-1" : "col-md-2"} mb-2`}>
                    {indexA + 1}.{indexQ + 1}
                  </div>
                  <div className="col-12 col-md-2 mb-2">
                    <label className="form-label d-block d-md-none mt-2">
                      Descripción
                    </label>
                    <span className="me-2">
                      {indexA + 1}.{indexQ + 1}.1.
                    </span>
                    {question.Titulo}
                  </div>
                  <div className="col-12 col-md-2 mb-2">
                    <label className="form-label d-block d-md-none mt-2">
                      Ubicación
                    </label>
                    <span className="me-2">
                      {indexA + 1}.{indexQ + 1}.2
                    </span>
                    {question.Titulo2}
                  </div>
                  <div className={`col-12 ${showCategory ? "col-md-1" : "col-md-2"} mb-2`}>
                    <label className="form-label d-block d-md-none mt-2">
                      Evaluación
                    </label>
                    <select
                      className="form-select"
                      name={`psn-${action.Id}-${question.Id}`}
                      value={formik.values[`psn-${action.Id}-${question.Id}`] || ""}
                      onChange={formik.handleChange}
                    >
                      <option value="" hidden>Seleccione...</option>
                      {questions.map(q => (
                        <option key={q.id} value={q.id}>
                          {q.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  {showCategory && (
                  <div className="col-12 col-md-1 mb-2">
                    <label className="form-label d-block d-md-none mt-2">
                      Categoría
                    </label>
                    {renderCategorySelect(inlineImgKey(action.Id, question.Id))}
                  </div>
                  )}
                  <div className="col-12 col-md-2 mb-2">
                    <label className="form-label d-block d-md-none mt-2">
                      Hallazgos
                    </label>
                    <textarea
                      rows="2"
                      className="form-control"
                      name={`po-${action.Id}-${question.Id}`}
                      value={
                        formik.values[`po-${action.Id}-${question.Id}`] || ""
                      }
                      onChange={formik.handleChange}
                      placeholder="Escriba aquí."
                    />
                  </div>
                  <div className="col-12 col-md-3 my-2 my-md-0">
                    {renderInlineActions(
                      inlineImgKey(action.Id, question.Id),
                      formik.values[`po-${action.Id}-${question.Id}`] || "",
                      formik.values[`psn-${action.Id}-${question.Id}`] || ""
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </FormSection>

      <FormSection title="III DETALLE INSPECCIÓN" show={form?.FormType === 6}>
        <FormSubSection
          title="Listado de elementos evaluados"
          show={true}
          action={() => handleAddElement()}
          actionContent={
            <>
              <FontAwesomeIcon icon={faPlus} />
              <span className="ms-2 d-none d-md-block">Agregar elemento</span>
            </>
          }
        >
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">
                    <span className="text-nowrap">Nombre elemento</span>
                  </th>
                  <th scope="col">
                    Descripción <h6 className="text-danger m-0 d-inline">*</h6>
                  </th>
                  <th scope="col">Estado</th>
                  <th scope="col">Comentarios</th>
                  <th scope="col">Acción</th>
                </tr>
              </thead>
              <tbody>
                {elements.map((element, index) => (
                  <tr key={element.id}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={elements[index]?.name || ""}
                        onChange={({target}) =>
                          handleOnChangeElements(index, "name", target.value)
                        }
                        style={{minWidth: 150}}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={elements[index]?.description || ""}
                        onChange={({target}) =>
                          handleOnChangeElements(
                            index,
                            "description",
                            target.value
                          )
                        }
                        style={{minWidth: 150}}
                        required
                      />
                    </td>
                    <td>
                      <select
                        className="form-select"
                        value={elements[index]?.state || ""}
                        onChange={({target}) =>
                          handleOnChangeElements(index, "state", target.value)
                        }
                        style={{minWidth: 150}}
                      >
                        <option value="" hidden>
                          Seleccione...
                        </option>
                        {states.map(st => (
                          <option key={st.id} value={st.id}>
                            {st.title}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={elements[index]?.comments || ""}
                        onChange={({target}) =>
                          handleOnChangeElements(
                            index,
                            "comments",
                            target.value
                          )
                        }
                        style={{minWidth: 150}}
                      />
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => handleRemoveElement(element.id)}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </FormSubSection>

        <FormSubSection title="Detalle inspección elemento" show={true}>
          <div className="row d-none d-md-flex">
            <div className={showCategory ? "col-3" : "col-4"}>
              <h6 className="text-center">Conceptos</h6>
            </div>
            <div className={showCategory ? "col-2" : "col-3"}>
              <h6 className="text-center">Evaluación</h6>
            </div>
            {showCategory && (
              <div className="col-2">
                <h6 className="text-center">Categoría</h6>
              </div>
            )}
            <div className="col-2">
              <h6 className="text-center">Hallazgos</h6>
            </div>
            <div className="col-3">
              <h6 className="text-center">Acciones</h6>
            </div>
          </div>
          {_.map(actions, (action, indexA) => (
            <div key={action.Id + indexA} className="row">
              <div className="col-12">
                <div className="border-top mt-2 mb-3">
                  <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
                </div>
              </div>
              {_.map(action.Preguntas, (question, indexQ) => (
                <div key={question.Id + indexQ} className="col-12 mb-4">
                  <div className="row">
                    <div className={`col-12 ${showCategory ? "col-md-3" : "col-md-4"}`}>
                      <label className="form-label d-block d-md-none mt-2">
                        Concepto
                      </label>
                      <span className="fw-bolder me-2">
                        {indexA + 1}.{indexQ + 1}.
                      </span>
                      {question.Titulo}
                    </div>
                    <div className={`col-12 ${showCategory ? "col-md-2" : "col-md-3"}`}>
                      <label className="form-label d-block d-md-none mt-2">
                        Evaluación
                      </label>
                      <select
                        className="form-select"
                        name={`psn-${action.Id}-${question.Id}`}
                        value={formik.values[`psn-${action.Id}-${question.Id}`] || ""}
                        onChange={formik.handleChange}
                      >
                        <option value="" hidden>Seleccione...</option>
                        {questions.map(q => (
                          <option key={q.id} value={q.id}>
                            {q.title}
                          </option>
                        ))}
                      </select>
                    </div>
                    {showCategory && (
                    <div className="col-12 col-md-2">
                      <label className="form-label d-block d-md-none mt-2">
                        Categoría
                      </label>
                      {renderCategorySelect(inlineImgKey(action.Id, question.Id))}
                    </div>
                    )}
                    <div className="col-12 col-md-2">
                      <label className="form-label d-block d-md-none mt-2">
                        Hallazgos
                      </label>
                      <textarea
                        rows="2"
                        className="form-control"
                        name={`po-${action.Id}-${question.Id}`}
                        value={
                          formik.values[`po-${action.Id}-${question.Id}`] || ""
                        }
                        onChange={formik.handleChange}
                        placeholder="Escriba aquí."
                      />
                    </div>
                    <div className="col-12 col-md-3 my-2 my-md-0">
                      {renderInlineActions(
                        inlineImgKey(action.Id, question.Id),
                        formik.values[`po-${action.Id}-${question.Id}`] || "",
                        formik.values[`psn-${action.Id}-${question.Id}`] || ""
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </FormSubSection>
      </FormSection>

      <FormSection
        title="III DETALLE INSPECCIÓN"
        show={form?.FormType === 8}
        action={() => handleAddSectionToCollaborator()}
        actionContent={
          <>
            <FontAwesomeIcon icon={faPlus} />
            <span className="ms-2 d-none d-md-block">Agregar sección</span>
          </>
        }
      >
        <div className="row">
          <div className="col-12">
            <h6 className="text-blue-cermaq text-center mb-md-5">
              {collaborators[collaboratorIndex]?.rut
                ? `${collaborators[collaboratorIndex]?.name} | ${collaborators[collaboratorIndex]?.rut}`
                : "Seleccione un colaborador..."}
            </h6>
          </div>
        </div>
        <div className="row d-none d-md-flex">
          <div className={showCategory ? "col-2" : "col-3"}>
            <h6 className="text-center">Conceptos</h6>
          </div>
          <div className={showCategory ? "col-2" : "col-3"}>
            <h6 className="text-center">Evaluación</h6>
          </div>
          {showCategory && (
            <div className="col-2">
              <h6 className="text-center">Categoría</h6>
            </div>
          )}
          <div className="col-2">
            <h6 className="text-center">Hallazgos</h6>
          </div>
          <div className="col-3">
            <h6 className="text-center">Acciones</h6>
          </div>
          <div className="col-1"></div>
        </div>
        {_.map(collaborators[collaboratorIndex]?.sections, (sec, secIndex) => (
          <div key={secIndex} className="row">
            <div className="col-12">
              <div className="border-top mt-2 mb-3">
                <h6 className="text-blue-cermaq mt-3">
                  Nombre sección {secIndex + 1}
                </h6>
              </div>
            </div>

            <div className={`col-12 ${showCategory ? "col-md-2" : "col-md-3"}`}>
              <label className="form-label d-block d-md-none mt-2">
                Concepto
              </label>
              <textarea
                rows="2"
                className="form-control"
                placeholder="Escriba aquí."
                disabled={!collaborators.length}
                value={sec.section || ""}
                onChange={({target}) =>
                  handleOnChangeCollaboratorsSection(
                    collaboratorIndex,
                    secIndex,
                    "section",
                    target.value
                  )
                }
              />
            </div>
            <div className={`col-12 ${showCategory ? "col-md-2" : "col-md-3"}`}>
              <label className="form-label d-block d-md-none mt-2">
                Evaluación
              </label>
              <select
                className="form-select"
                disabled={!collaborators.length}
                value={sec.yn || ""}
                onChange={({target}) =>
                  handleOnChangeCollaboratorsSection(
                    collaboratorIndex,
                    secIndex,
                    "yn",
                    target.value
                  )
                }
              >
                <option value="" hidden>Seleccione...</option>
                {questions.map(question => (
                  <option key={question.id} value={question.id}>
                    {question.title}
                  </option>
                ))}
              </select>
            </div>
            {showCategory && (
            <div className="col-12 col-md-2">
              <label className="form-label d-block d-md-none mt-2">
                Categoría
              </label>
              {renderCategorySelect(inlineImgKey("collab", `${collaboratorIndex}-${sec.id}`))}
            </div>
            )}
            <div className="col-12 col-md-2">
              <label className="form-label d-block d-md-none mt-2">
                Hallazgos
              </label>
              <textarea
                rows="2"
                className="form-control"
                placeholder="Escriba aquí."
                disabled={!collaborators.length}
                value={sec.observation || ""}
                onChange={({target}) =>
                  handleOnChangeCollaboratorsSection(
                    collaboratorIndex,
                    secIndex,
                    "observation",
                    target.value
                  )
                }
              />
            </div>
            <div className="col-12 col-md-3 my-2 my-md-0">
              {renderInlineActions(
                inlineImgKey("collab", `${collaboratorIndex}-${sec.id}`),
                sec.observation || "",
                sec.yn || ""
              )}
            </div>
            <div className="col-12 col-md-1 my-2 my-md-0">
              <button
                type="button"
                className="btn bg-danger btn-sm text-white w-100 d-flex align-items-center justify-content-center"
                onClick={() => handleRemoveCollaboratorSection(sec.id)}
              >
                <FontAwesomeIcon icon={faXmark} />
                <span className="d-block d-md-none ms-3">Eliminar</span>
              </button>
            </div>
          </div>
        ))}
      </FormSection>

      <FormSection title="III DETALLE INSPECCIÓN" show={form?.FormType === 9}>
        <div className="row d-none d-md-flex">
          <div className={showCategory ? "col-3" : "col-4"}>
            <h6 className="text-center">Preguntas</h6>
          </div>
          <div className={showCategory ? "col-2" : "col-3"}>
            <h6 className="text-center">Evaluación</h6>
          </div>
          {showCategory && (
            <div className="col-2">
              <h6 className="text-center">Categoría</h6>
            </div>
          )}
          <div className="col-2">
            <h6 className="text-center">Hallazgos</h6>
          </div>
          <div className="col-3">
            <h6 className="text-center">Acciones</h6>
          </div>
        </div>
        {_.map(actions, (action, indexA) => (
          <div key={action.Id + indexA} className="row">
            <div className="col-12">
              <div className="border-top mt-2 mb-3">
                <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
              </div>
            </div>
            {_.map(action.Preguntas, (question, indexQ) => (
              <div key={question.Id + indexQ} className="col-12 mb-4">
                <div className="row">
                  <div className={`col-12 ${showCategory ? "col-md-3" : "col-md-4"}`}>
                    <label className="form-label d-block d-md-none">
                      Concepto
                    </label>
                    <span className="fw-bolder me-2">
                      {indexA + 1}.{indexQ + 1}.
                    </span>
                    {question.Titulo}
                  </div>
                  <div className={`col-12 ${showCategory ? "col-md-2" : "col-md-3"}`}>
                    <label className="form-label mt-3 d-block d-md-none">
                      Evaluación
                    </label>
                    <select
                      className="form-select"
                      name={`psn-${action.Id}-${question.Id}`}
                      value={formik.values[`psn-${action.Id}-${question.Id}`] || ""}
                      onChange={formik.handleChange}
                    >
                      <option value="" hidden>Seleccione...</option>
                      {questions.map(q => (
                        <option key={q.id} value={q.id}>
                          {q.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  {showCategory && (
                  <div className="col-12 col-md-2">
                    <label className="form-label mt-3 d-block d-md-none">
                      Categoría
                    </label>
                    {renderCategorySelect(inlineImgKey(action.Id, question.Id))}
                  </div>
                  )}
                  <div className="col-12 col-md-2">
                    <label className="form-label mt-3 d-block d-md-none">
                      Hallazgos
                    </label>
                    <textarea
                      rows="2"
                      className="form-control"
                      name={`po-${action.Id}-${question.Id}`}
                      value={
                        formik.values[`po-${action.Id}-${question.Id}`] || ""
                      }
                      onChange={formik.handleChange}
                      placeholder="Escriba aquí."
                    />
                  </div>
                  <div className="col-12 col-md-3 my-2 my-md-0">
                    {renderInlineActions(
                      inlineImgKey(action.Id, question.Id),
                      formik.values[`po-${action.Id}-${question.Id}`] || "",
                      formik.values[`psn-${action.Id}-${question.Id}`] || ""
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}

        <div className="row">
          <div className="col-12">
            <div className="border-top mt-2 mb-3">
              <h6 className="text-blue-cermaq mt-3">
                INSPECCIÓN ESPECÍFICA DE LA MAQUINARIA
              </h6>
            </div>
          </div>

          {_.map(questionsMachine, (question, index) => (
            <div key={question.id} className="col-12 mb-4">
              <div className="row">
                <div className={`col-12 ${showCategory ? "col-md-3" : "col-md-4"}`}>
                  <label className="form-label d-block d-md-none">
                    Pregunta
                  </label>
                  <span className="fw-bolder me-2">
                    {form.Acciones.length + 1}.{index + 1}.
                  </span>
                  {question.title}
                </div>
                <div className={`col-12 ${showCategory ? "col-md-2" : "col-md-3"}`}>
                  <label className="form-label mt-3 d-block d-md-none">
                    Evaluación
                  </label>
                  <select
                    className="form-select"
                    value={machines[index]?.yesOrNo || ""}
                    onChange={({target}) =>
                      handleOnChangeMachines(index, "yesOrNo", target.value)
                    }
                  >
                    <option value="" hidden>Seleccione...</option>
                    {questions.map(q => (
                      <option key={q.id} value={q.id}>
                        {q.title}
                      </option>
                    ))}
                  </select>
                </div>
                {showCategory && (
                <div className="col-12 col-md-2">
                  <label className="form-label mt-3 d-block d-md-none">
                    Categoría
                  </label>
                  {renderCategorySelect(inlineImgKey("machine", index))}
                </div>
                )}
                <div className="col-12 col-md-2">
                  <label className="form-label mt-3 d-block d-md-none">
                    Hallazgos
                  </label>
                  <textarea
                    rows="2"
                    className="form-control"
                    value={machines[index]?.comments || ""}
                    onChange={({target}) =>
                      handleOnChangeMachines(index, "comments", target.value)
                    }
                    placeholder="Escriba aquí."
                  />
                </div>
                <div className="col-12 col-md-3 my-2 my-md-0">
                  {renderInlineActions(
                    inlineImgKey("machine", index),
                    machines[index]?.comments || "",
                    machines[index]?.yesOrNo || ""
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </FormSection>

      {/* ============ BUCEO - FormType 12 ============ */}
      <FormSection title="II DATOS DE LA FAENA" show={form?.FormType === 12}>
        <div className="row">
          <div className="col-12 col-md-4 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">1.</span> Localización exacta del trabajo{" "}
              <h5 className="text-danger m-0 d-inline">*</h5>
            </label>
            <input type="text" className="form-control" name="buceo-localizacion"
              value={formik.values["buceo-localizacion"] || ""} onChange={formik.handleChange} required />
          </div>
          <div className="col-12 col-md-4 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">2.</span> Ejecución del trabajo{" "}
              <h5 className="text-danger m-0 d-inline">*</h5>
            </label>
            <select className="form-select" name="buceo-ejecucion"
              value={formik.values["buceo-ejecucion"] || ""} onChange={formik.handleChange} required>
              <option value="" hidden>Seleccione...</option>
              {executionTypes.map(et => (
                <option key={et.id} value={et.title}>{et.title}</option>
              ))}
            </select>
          </div>
          <div className="col-12 col-md-4 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">3.</span> Tipo de trabajo{" "}
              <h5 className="text-danger m-0 d-inline">*</h5>
            </label>
            <select className="form-select" name="buceo-tipoTrabajo"
              value={formik.values["buceo-tipoTrabajo"] || ""} onChange={formik.handleChange} required>
              <option value="" hidden>Seleccione...</option>
              {workTypes.map(wt => (
                <option key={wt.id} value={wt.title}>{wt.title}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-4 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">4.</span> Supervisor de Buceo
            </label>
            <input type="text" className="form-control mb-2" name="buceo-supNombre" placeholder="Nombre"
              value={formik.values["buceo-supNombre"] || ""} onChange={formik.handleChange} />
            <input type="tel" className="form-control" name="buceo-supFono" placeholder="Fono"
              value={formik.values["buceo-supFono"] || ""} onChange={formik.handleChange} />
          </div>
          <div className="col-12 col-md-4 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">5.</span> Jefe de Centro
            </label>
            <input type="text" className="form-control mb-2" name="buceo-jefeNombre" placeholder="Nombre"
              value={formik.values["buceo-jefeNombre"] || ""} onChange={formik.handleChange} />
            <input type="tel" className="form-control" name="buceo-jefeFono" placeholder="Fono"
              value={formik.values["buceo-jefeFono"] || ""} onChange={formik.handleChange} />
          </div>
          <div className="col-12 col-md-4 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">6.</span> Capitán o Patrón embarcación
            </label>
            <input type="text" className="form-control mb-2" name="buceo-capitanNombre" placeholder="Nombre"
              value={formik.values["buceo-capitanNombre"] || ""} onChange={formik.handleChange} />
            <input type="tel" className="form-control" name="buceo-capitanFono" placeholder="Fono"
              value={formik.values["buceo-capitanFono"] || ""} onChange={formik.handleChange} />
          </div>
        </div>

        <div className="row">
          <div className="col-12 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">7.</span> Descripción de los trabajos a realizar{" "}
              <small className="text-muted">(tipo, profundidad máxima y equipo a utilizar)</small>
            </label>
            <textarea rows="3" className="form-control" name="buceo-descripcion"
              value={formik.values["buceo-descripcion"] || ""} onChange={formik.handleChange} />
          </div>
        </div>

        <div className="d-flex align-items-center border-top pt-3 mt-2 mb-2">
          <h6 className="text-blue-cermaq mb-0">Trabajadores involucrados en la Faena</h6>
          <button type="button" className="btn bg-primary text-white ms-auto d-flex align-items-center"
            onClick={() => handleAddCollaborator()}>
            <FontAwesomeIcon icon={faPlus} />
            <span className="ms-2 d-none d-md-block">Agregar trabajador</span>
          </button>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Rut</th>
                <th scope="col">Nombre</th>
                <th scope="col">Firma</th>
                <th scope="col">Acción</th>
              </tr>
            </thead>
            <tbody>
              {collaborators.map((collaborator, index) => (
                <tr key={collaborator.id}>
                  <th scope="row">
                    <div className="d-flex align-items-center" style={{height: 38}}>
                      <span>{index + 1}</span>
                    </div>
                  </th>
                  <td>
                    <input type="text" className="form-control"
                      value={collaborators[index]?.rut}
                      onChange={({target}) => handleOnChangeCollaborators(index, "rut", target.value)}
                      style={{minWidth: 100}} />
                  </td>
                  <td>
                    <input type="text" className="form-control"
                      value={collaborators[index]?.name}
                      onChange={({target}) => handleOnChangeCollaborators(index, "name", target.value)}
                      style={{minWidth: 150}} />
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <button type="button" className="btn bg-primary text-white fs-6 me-auto text-nowrap"
                        onClick={() => setCollaboratorSignature(collaborator)}>
                        <FontAwesomeIcon icon={faPenClip} className="me-2" />Firma
                      </button>
                      {collaborator["signature"] && (
                        <button type="button" className="btn bg-danger text-white fs-6 me-auto ms-1"
                          onClick={() => removeSignature(collaborator)}>
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      )}
                    </div>
                  </td>
                  <td>
                    <button type="button" className="btn btn-danger"
                      onClick={() => handleRemoveCollaborator(collaborator.id)}>
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </FormSection>
      <FormSection
        title="III ETAPAS DEL TRABAJO, PELIGROS Y CONTROLES"
        show={form?.FormType === 12}
      >
        <div className="row d-none d-md-flex">
          <div className="col-4">
            <h6 className="text-center">Etapa del Trabajo</h6>
          </div>
          <div className="col-4">
            <h6 className="text-center">Peligros Presentes</h6>
          </div>
          <div className="col-4">
            <h6 className="text-center">Controles Operacionales</h6>
          </div>
        </div>

        {/* Etapas fijas del template (Accion Id "1") */}
        {actions.filter(a => a.Id === "1").map((action, indexA) => (
          <div key={action.Id + indexA} className="row mt-4">
            {_.map(action.Preguntas, (question, indexQ) => (
              <div key={question.Id + indexQ} className="col-12 mb-4 border-bottom">
                <div className="row">
                  <div className="col-12 col-md-4">
                    <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                      Etapa del Trabajo
                    </label>
                    <p className="m-0">{question?.Tareas?.Titulo}</p>
                    <ul className="fs-6">
                      {_.map(question?.Tareas?.Items, (item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                      Peligros Presentes
                    </label>
                    <ul className="fs-6">
                      {_.map(question?.Peligros, (danger, i) => (
                        <li key={i}>{danger}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                      Controles Operacionales
                    </label>
                    <ul className="fs-6">
                      {_.map(question?.Medidas, (medida, i) => (
                        <li key={i}>{medida}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}

        {/* Sección "Otros" - etapas editables */}
        <div className="row mb-4 d-flex">
          <div className="col-6 my-auto">
            <h6 className="text-blue-cermaq">Otros</h6>
          </div>
          <div className="col-6 my-auto">
            <button
              type="button"
              className="btn bg-primary text-white ms-auto d-flex align-items-center"
              onClick={() => handleAddSection()}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span className="ms-2 d-none d-md-block">Agregar etapa</span>
            </button>
          </div>
        </div>

        {sections.map((sec, index) => (
          <div key={sec.id} className="row mb-4 border-bottom">
            <div className="col-12 col-md-3 mb-2">
              <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                Etapa del Trabajo
              </label>
              <ul className="p-0" style={{listStyle: "none"}}>
                {_.map(sections[index]?.tasksItems, (item, itemIndex) => (
                  <li key={itemIndex} className="d-flex align-items-center mb-2">
                    <button type="button" className="btn btn-danger btn-sm me-2"
                      disabled={sections[index]?.tasksItems?.length < 2}
                      onClick={() => handleRemoveSectionItem(index, itemIndex, "tasksItems")}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <textarea rows="1" className="form-control" placeholder="Descripción de la etapa..."
                      value={item}
                      onChange={({target}) => handleOnChangeSectionItem(index, itemIndex, "tasksItems", target.value)} />
                  </li>
                ))}
                <li className="d-flex align-items-center">
                  <button type="button"
                    className="btn bg-primary text-white d-flex align-items-center justify-content-center btn-sm w-100"
                    onClick={() => handleAddSectionItem(index, "tasksItems")}>
                    <FontAwesomeIcon icon={faAdd} />
                    <span className="ms-3">Etapa</span>
                  </button>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-4 mb-2">
              <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                Peligros Presentes
              </label>
              <ul className="p-0" style={{listStyle: "none"}}>
                {_.map(sections[index]?.dangers, (item, itemIndex) => (
                  <li key={itemIndex} className="d-flex align-items-center mb-2">
                    <button type="button" className="btn btn-danger btn-sm me-2"
                      disabled={sections[index]?.dangers?.length < 2}
                      onClick={() => handleRemoveSectionItem(index, itemIndex, "dangers")}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <textarea rows="1" className="form-control" placeholder="Ingresa peligro..."
                      value={item}
                      onChange={({target}) => handleOnChangeSectionItem(index, itemIndex, "dangers", target.value)} />
                  </li>
                ))}
                <li className="d-flex align-items-center">
                  <button type="button"
                    className="btn bg-primary text-white d-flex align-items-center justify-content-center btn-sm w-100"
                    onClick={() => handleAddSectionItem(index, "dangers")}>
                    <FontAwesomeIcon icon={faAdd} />
                    <span className="ms-3">Peligro</span>
                  </button>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-4 mb-2">
              <label className="form-label d-block d-md-none text-blue-cermaq mt-2">
                Controles Operacionales
              </label>
              <ul className="p-0" style={{listStyle: "none"}}>
                {_.map(sections[index]?.precautionaryMeasures, (item, itemIndex) => (
                  <li key={itemIndex} className="d-flex align-items-center mb-2">
                    <button type="button" className="btn btn-danger btn-sm me-2"
                      disabled={sections[index]?.precautionaryMeasures?.length < 2}
                      onClick={() => handleRemoveSectionItem(index, itemIndex, "precautionaryMeasures")}>
                      <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <textarea rows="1" className="form-control" placeholder="Ingresa control operacional..."
                      value={item}
                      onChange={({target}) => handleOnChangeSectionItem(index, itemIndex, "precautionaryMeasures", target.value)} />
                  </li>
                ))}
                <li className="d-flex align-items-center">
                  <button type="button"
                    className="btn bg-primary text-white d-flex align-items-center justify-content-center btn-sm w-100"
                    onClick={() => handleAddSectionItem(index, "precautionaryMeasures")}>
                    <FontAwesomeIcon icon={faAdd} />
                    <span className="ms-3">Control operacional</span>
                  </button>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-1 mb-2 d-flex">
              <button type="button"
                className="btn btn-danger d-flex align-items-center justify-content-center w-100 mb-auto"
                onClick={() => handleRemoveSection(sec.id)}>
                <FontAwesomeIcon icon={faXmark} />
                <span className="d-block d-md-none ms-3">Eliminar</span>
              </button>
            </div>
          </div>
        ))}
      </FormSection>


      <FormSection title="IV DETALLE INSPECCIÓN" show={form?.FormType === 12}>
        <div className="row d-none d-md-flex">
          <div className="col-8">
            <h6 className="text-center">Conceptos</h6>
          </div>
          <div className="col-4">
            <h6 className="text-center">Evaluación</h6>
          </div>
        </div>
        {_.map(actions.filter(a => !a.Preguntas?.some(q => q.Tareas)), (action, indexA) => (
          <div key={action.Id + indexA} className="row">
            <div className="col-12">
              <div className="border-top mt-2 mb-3">
                <h6 className="text-blue-cermaq mt-3">{action.Titulo}</h6>
              </div>
            </div>
            {_.map(action.Preguntas, (question, indexQ) => (
              <div key={question.Id + indexQ} className="col-12 mb-4">
                <div className="row">
                  <div className="col-12 col-md-8">
                    <label className="form-label d-block d-md-none">Concepto</label>
                    <span className="fw-bolder me-2">{indexA + 1}.{indexQ + 1}.</span>
                    {question.Titulo}
                  </div>
                  <div className="col-12 col-md-4">
                    <label className="form-label mt-3 d-block d-md-none">Evaluación</label>
                    <select className="form-select"
                      name={`psn-${action.Id}-${question.Id}`}
                      value={formik.values[`psn-${action.Id}-${question.Id}`] || ""}
                      onChange={formik.handleChange}>
                      <option value="" hidden>Seleccione...</option>
                      {questions.map(q => (
                        <option key={q.id} value={q.id}>{q.title}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </FormSection>

      <FormSection title="REGISTRO PLANIFICACIÓN FAENAS DE BUCEO" show={form?.FormType === 12}>
        {(form?.Declaracion || []).length > 0 && (
          <div className="mb-4 p-3 bg-light border rounded">
            <p className="fw-bold mb-2">Declaración:</p>
            <ul className="mb-3">
              {form.Declaracion.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <div className="form-check mb-0">
              <input
                type="checkbox"
                className="form-check-input"
                id="buceo-declaracionLeida"
                name="buceo-declaracionLeida"
                checked={!!formik.values["buceo-declaracionLeida"]}
                onChange={e => {
                  formik.setFieldValue("buceo-declaracionLeida", e.target.checked);
                  if (!e.target.checked) {
                    formik.setFieldValue("p-5", "");
                    formik.setFieldValue("buceo-observacionesRechazo", "");
                  }
                }}
              />
              <label className="form-check-label fw-bold" htmlFor="buceo-declaracionLeida">
                He leído y comprendo la declaración anterior{" "}
                <span className="text-danger">*</span>
              </label>
            </div>
          </div>
        )}
      </FormSection>

      {/* ============ FIN BUCEO ============ */}

      <DialogFormFinding
        open={openFindings}
        control={setOpenFindings}
        edit={editFinding}
        finding={finding}
        isPreview={isPreviewFinding}
        questions={questions}
        findingCategories={findingCategories}
        isIncidentReport={isIncidentReport}
        showCategory={showCategory}
        totalImageCount={getTotalImageCount()}
        globalImgLimit={globalImgLimit}
      />

      <FormSection
        sectionId="sectionFinding"
        tabindex={0}
        title={isIncidentReport ? "III DETALLE HALLAZGOS ENCONTRADOS" : "IV DETALLE HALLAZGOS ENCONTRADOS"}
        show={(form?.FormType !== 11 && form?.FormType !== 12) || isIncidentReport}
      >
        <FindingGridIncident
          data={findings}
          remove={removeFinding}
          edit={openEditFinding}
          preview={openPreviewFinding}
          isIncidentReport={isIncidentReport}
          questions={questions}
        />
        {findings.length > 0 && (
          <div className={`mt-2 small ${getTotalImageCount() >= globalImgLimit ? "text-danger fw-bold" : getTotalImageCount() >= globalImgLimit - 3 ? "text-warning" : "text-muted"}`}>
            Imágenes: {getTotalImageCount()} / {globalImgLimit}
            {getTotalImageCount() >= globalImgLimit && " — Límite alcanzado"}
          </div>
        )}
      </FormSection>

      <DialogFormCommitments
        open={openCommitments}
        control={setOpenCommitments}
        findings={findings}
        add={addCommitment}
        edit={editCommitment}
        commitment={commitment}
        responsible={responsible}
        isPreview={isPreviewCommitment}
      />

      <FormSection
        title="V COMPROMISOS ADQUIRIDOS"
        show={form?.FormType !== 11 && form?.FormType !== 12 && !isIncidentReport}
        action={() => setOpenCommitments(true)}
        actionContent={
          <>
            <FontAwesomeIcon icon={faPlus} />
            <span className="ms-2 d-none d-md-block">Nuevo compromiso</span>
          </>
        }
      >
        <CommitmentsGrid
          data={commitments}
          remove={removeCommitment}
          edit={openEditCommitment}
          findings={findings}
          preview={openPreviewCommitment}
          responsible={responsible}
        />
      </FormSection>

      <FormSection title={form?.FormType === 12 ? "V RESULTADO INSPECCIÓN" : "VI RESULTADO INSPECCIÓN"} show={form?.FormType !== 11 && !isIncidentReport}>
        <div className="row">
          <div className="col-12 col-md-4 mb-3">
            <label className="form-label">
              <span className="fw-bolder me-2">1.</span> Resultado{" "}
              <h6 className="text-danger m-0 d-inline">*</h6>
            </label>
            <select
              className="form-select"
              name="p-5"
              value={formik.values["p-5"]}
              onChange={e => {
                formik.handleChange(e);
                if (form?.FormType === 12) {
                  const selected = results.find(r => String(r.id) === e.target.value);
                  if (selected?.title?.toLowerCase().includes("aprobad") && !selected.title.toLowerCase().includes("no aprobad")) {
                    formik.setFieldValue("buceo-observacionesRechazo", "");
                  }
                }
              }}
              required
              disabled={form?.FormType === 12 && !formik.values["buceo-declaracionLeida"]}
            >
              <option value="" hidden>
                Seleccione...
              </option>
              {results.map(result => (
                <option key={result.id} value={result.id}>
                  {result.title}
                </option>
              ))}
            </select>
            {form?.FormType === 12 && !formik.values["buceo-declaracionLeida"] && (
              <small className="text-muted">Debe confirmar la declaración para seleccionar el resultado</small>
            )}
          </div>
        </div>
        {form?.FormType === 12 && (() => {
          const selected = results.find(r => String(r.id) === String(formik.values["p-5"]));
          const isNoAprobada = selected?.title?.toLowerCase().includes("no aprobad");
          return isNoAprobada ? (
            <div className="row">
              <div className="col-12 mb-3">
                <label className="form-label">
                  Observaciones a subsanar{" "}
                  <span className="text-danger">*</span>
                </label>
                <textarea
                  rows="3"
                  className="form-control"
                  name="buceo-observacionesRechazo"
                  placeholder="Debe subsanar las observaciones y repetir el llenado del registro..."
                  value={formik.values["buceo-observacionesRechazo"] || ""}
                  onChange={formik.handleChange}
                  required
                />
              </div>
            </div>
          ) : null;
        })()}
      </FormSection>

      <div className="row mt-5 pb-5">
        <div className="col-12">
          <div className="d-flex justify-content-evenly">
            {saving && (
              <div
                className="btn bg-secondary text-white fs-6 d-flex align-items-center disabled"
                disabled
              >
                <div
                  className="spinner-border text-light"
                  role="status"
                  style={{width: "1.4rem", height: "1.4rem"}}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <span className="ms-3">Guardando...</span>
              </div>
            )}

            {online && state === LOCAL_NEW_STATE && !saving && (
              <button type="submit" className="btn bg-warning text-white fs-6">
                Sync Guardado
              </button>
            )}

            {online && state === LOCAL_UPDATE_STATE && !saving && (
              <button type="submit" className="btn bg-warning text-white fs-6">
                Sync Actualización
              </button>
            )}

            {((online &&
              state !== LOCAL_UPDATE_STATE &&
              state !== LOCAL_NEW_STATE) ||
              !online) &&
              !saving && (
                <button
                  type="submit"
                  className="btn bg-success text-white fs-6"
                >
                  Guardar datos
                </button>
              )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default Forms;
